import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: Date; output: Date; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type AcceptResetPasswordOutputObjectType = {
  __typename?: 'AcceptResetPasswordOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdjustQuestionsPValuesInput = {
  endAt: Scalars['DateTime']['input'];
  minimumExamineePerQuestion: Scalars['Int']['input'];
  pValue: PValueThresholdInput;
  qBankStructureId: Scalars['String']['input'];
  questionStatus?: InputMaybe<Array<QuestionStatus>>;
  startAt: Scalars['DateTime']['input'];
};

export type AdjustQuestionsPValuesOutput = {
  __typename?: 'AdjustQuestionsPValuesOutput';
  message: Scalars['String']['output'];
  status: GenericResponseStatus;
};

export type AnswerCount = {
  __typename?: 'AnswerCount';
  answer: Scalars['String']['output'];
  total: Maybe<Scalars['Int']['output']>;
};

export type AppPermission = {
  __typename?: 'AppPermission';
  action: Scalars['String']['output'];
  category: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AppRole = {
  __typename?: 'AppRole';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
};

export type AppRoleIdsInput = {
  appRoleIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AppRoleSearchInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AppRoleSearchResult = {
  __typename?: 'AppRoleSearchResult';
  roles: Array<AppRole>;
  total: Scalars['Int']['output'];
};

export type AssignUserAppRoleInput = {
  appRoleId: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']>;
};

export type AssignUserAppRoleMutationResponse = {
  __typename?: 'AssignUserAppRoleMutationResponse';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user: Maybe<Array<UserAppRoleView>>;
};

export type AssignUserAppRolesInput = {
  appRoleIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AssignUserAppRolesMutationResponse = {
  __typename?: 'AssignUserAppRolesMutationResponse';
  appRoles: Maybe<Array<AppRole>>;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type BIndexThreshold = {
  type: BIndexThresholdType;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export enum BIndexThresholdType {
  CustomThreshold = 'CUSTOM_THRESHOLD',
  UseExamResult = 'USE_EXAM_RESULT'
}

export type ClearSessionOutputObjectType = {
  __typename?: 'ClearSessionOutputObjectType';
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CountExamEventReportItemSummaryInput = {
  endedAt: Scalars['DateTime']['input'];
  examCenterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  examTypes: Array<ExamType>;
  provinceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  registrationTypes: Array<RegistrationType>;
  startedAt: Scalars['DateTime']['input'];
};

export type CountExamEventReportItemSummaryOutput = {
  __typename?: 'CountExamEventReportItemSummaryOutput';
  _summaryTypeRef: Maybe<ExamEventReportItemSummaryType>;
  summariesCount: Scalars['JSONObject']['output'];
};

export type CreateAppRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};

export type CreateAppRoleMutationResponse = {
  __typename?: 'CreateAppRoleMutationResponse';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  newAppRole: AppRole;
  success: Scalars['Boolean']['output'];
};

export type DeleteAppRoleInput = {
  appRoleId: Scalars['String']['input'];
};

export type DeleteAppRoleMutationResponse = {
  __typename?: 'DeleteAppRoleMutationResponse';
  appRole: AppRole;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExamCenter = {
  __typename?: 'ExamCenter';
  addressEn: Maybe<Scalars['String']['output']>;
  addressTh: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  email: Maybe<Scalars['String']['output']>;
  examCenterId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  logoSrc: Maybe<Scalars['String']['output']>;
  nameEn: Scalars['String']['output'];
  nameTh: Scalars['String']['output'];
  phoneEn: Maybe<Scalars['String']['output']>;
  phoneTh: Maybe<Scalars['String']['output']>;
  scoreReportUrl: Maybe<Scalars['String']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

export type ExamCourse = {
  __typename?: 'ExamCourse';
  code: Scalars['String']['output'];
  examId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ExamCourseAnalysisReportItem = {
  __typename?: 'ExamCourseAnalysisReportItem';
  applicantExamineeCount: RegisteredTypeValue;
  attendedExamineeCount: RegisteredTypeValue;
  averageScore: Scalars['Float']['output'];
  avgAttempts: Maybe<Scalars['Float']['output']>;
  examCourse: Maybe<ExamCourse>;
  examCourseCode: Scalars['String']['output'];
  examCourseType: ExamCourseType;
  examId: Scalars['Int']['output'];
  failedExamineeCount: RegisteredTypeValue;
  fullScore: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  maxScore: Scalars['Float']['output'];
  minScore: Scalars['Float']['output'];
  passedExamineeCount: RegisteredTypeValue;
  passedRate: PercentageValueWithRegisteredType;
  qConfigRef: Scalars['Int']['output'];
  standardDeviationScore: Scalars['Float']['output'];
  uniqueExamineeCount: Scalars['Int']['output'];
};

export enum ExamCourseType {
  Main = 'MAIN',
  Mock = 'MOCK'
}

export type ExamEventReportItem = {
  __typename?: 'ExamEventReportItem';
  absentExamineeCount: Scalars['Float']['output'];
  attendedExamineeCount: Scalars['Float']['output'];
  canceledExamineeCount: Scalars['Float']['output'];
  endedAt: Scalars['DateTime']['output'];
  examCenterCode: Scalars['String']['output'];
  examEventId: Scalars['String']['output'];
  examType: ExamType;
  examineeCount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  location: Maybe<Location>;
  locationId: Scalars['String']['output'];
  province: Maybe<Province>;
  provinceId: Scalars['String']['output'];
  registeredExamineeCount: Scalars['Float']['output'];
  registrationType: RegistrationType;
  seatCount: Scalars['Float']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export type ExamEventReportItemFilterInput = {
  endedAt: Scalars['DateTime']['input'];
  examCenterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  examTypes: Array<ExamType>;
  provinceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  registrationTypes: Array<RegistrationType>;
  startedAt: Scalars['DateTime']['input'];
};

export enum ExamEventReportItemSummaryType {
  AbsentExamineeCount = 'ABSENT_EXAMINEE_COUNT',
  AttendedExamineeCount = 'ATTENDED_EXAMINEE_COUNT',
  CanceledExamineeCount = 'CANCELED_EXAMINEE_COUNT',
  EventCount = 'EVENT_COUNT',
  RegisteredExamineeCount = 'REGISTERED_EXAMINEE_COUNT',
  SeatCount = 'SEAT_COUNT'
}

export type ExamQSetUsageRecord = {
  __typename?: 'ExamQSetUsageRecord';
  averageScore: Scalars['Float']['output'];
  endedAt: Maybe<Scalars['DateTime']['output']>;
  examCourseCode: Scalars['String']['output'];
  examineeCount: Scalars['Int']['output'];
  maxScore: Scalars['Float']['output'];
  minScore: Scalars['Float']['output'];
  pAverage: Scalars['Float']['output'];
  passedExamineeCount: Scalars['Int']['output'];
  passedRate: Scalars['Float']['output'];
  qConfigRef: Scalars['Int']['output'];
  qSetCode: Scalars['String']['output'];
  standardDeviationScore: Scalars['Float']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export enum ExamType {
  Computer = 'COMPUTER',
  Paper = 'PAPER'
}

export type ExportExamCourseAnalysisReportFilterInput = {
  endedAt: Scalars['DateTime']['input'];
  examCenterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  examCourseCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  examCourseTypes: Array<ExamCourseType>;
  qConfigRefs?: InputMaybe<Array<Scalars['Int']['input']>>;
  startedAt: Scalars['DateTime']['input'];
};

export type ExportExamCourseAnalysisReportInput = {
  filter: ExportExamCourseAnalysisReportFilterInput;
  order?: InputMaybe<OrderInput>;
};

export type ExportExamCourseAnalysisReportOutput = {
  __typename?: 'ExportExamCourseAnalysisReportOutput';
  signedUrl: Scalars['String']['output'];
};

export type ExportExamEventReportItemsInput = {
  filter: ExamEventReportItemFilterInput;
  order?: InputMaybe<OrderInput>;
};

export type ExportExamEventReportItemsOutput = {
  __typename?: 'ExportExamEventReportItemsOutput';
  signedUrl: Scalars['String']['output'];
};

export type ExportExamQSetUsageRecordsInput = {
  filter: SearchExamQSetUsageFilterInput;
};

export type ExportExamQSetUsageRecordsOutput = {
  __typename?: 'ExportExamQSetUsageRecordsOutput';
  signedUrl: Scalars['String']['output'];
};

export type ExportQuestionItemAnalysisRecordsInput = {
  endAt: Scalars['DateTime']['input'];
  knowledgeGroup: BIndexThreshold;
  minimumExamineePerQuestion: Scalars['Int']['input'];
  nonKnowledgeGroup: BIndexThreshold;
  pValue: PValueThresholdInput;
  qBankStructureId: Scalars['String']['input'];
  questionStatus?: InputMaybe<Array<QuestionStatus>>;
  startAt: Scalars['DateTime']['input'];
};

export type ExportQuestionItemAnalysisRecordsOutput = {
  __typename?: 'ExportQuestionItemAnalysisRecordsOutput';
  signedUrl: Scalars['String']['output'];
};

export type ExportQuestionItemAnalysisYearlyRecordsInput = {
  endedAt: Scalars['DateTime']['input'];
  knowledgeGroup: BIndexThreshold;
  minimumExamineePerQuestion: Scalars['Int']['input'];
  nonKnowledgeGroup: BIndexThreshold;
  qBankStructureId: Scalars['String']['input'];
  questionStatus?: InputMaybe<Array<QuestionStatus>>;
  startedAt: Scalars['DateTime']['input'];
};

export type ExportQuestionItemAnalysisYearlyRecordsOutput = {
  __typename?: 'ExportQuestionItemAnalysisYearlyRecordsOutput';
  signedUrl: Scalars['String']['output'];
};

export type ExportQuestionQSetUsageRecordsInput = {
  examCourseId: Scalars['String']['input'];
  qSetStatuses?: InputMaybe<Array<QSetStatus>>;
};

export type ExportQuestionQSetUsageRecordsOutput = {
  __typename?: 'ExportQuestionQSetUsageRecordsOutput';
  signedUrl: Scalars['String']['output'];
};

export type ExportQuestionnaireSummaryReportInput = {
  endedAt: Scalars['DateTime']['input'];
  examCenterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  examCourseCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  startedAt: Scalars['DateTime']['input'];
  templates: Array<QuestionnaireTemplate>;
};

export type ExportQuestionnaireSummaryReportOutput = {
  __typename?: 'ExportQuestionnaireSummaryReportOutput';
  signedUrl: Scalars['String']['output'];
};

export type GenerateTwoFactorSecretOutputObjectType = {
  __typename?: 'GenerateTwoFactorSecretOutputObjectType';
  email: Scalars['String']['output'];
  issuer: Scalars['String']['output'];
  secret: Scalars['String']['output'];
};

export enum GenericResponseStatus {
  Success = 'SUCCESS'
}

export type GetAllExamCentersOutput = {
  __typename?: 'GetAllExamCentersOutput';
  examCenters: Array<ExamCenter>;
};

export type GetAllExamCoursesOutput = {
  __typename?: 'GetAllExamCoursesOutput';
  examCourses: Array<ExamCourse>;
};

export type GetAllProvincesOutput = {
  __typename?: 'GetAllProvincesOutput';
  provinces: Array<Province>;
};

export type GetAllQBankStructuresInput = {
  statuses?: InputMaybe<Array<QBankStructureStatus>>;
};

export type GetAllQBankStructuresOutput = {
  __typename?: 'GetAllQBankStructuresOutput';
  qBankStructures: Array<QBankStructure>;
};

export type GetAppRoleOutputObjectType = {
  __typename?: 'GetAppRoleOutputObjectType';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type GetAvailableExamEventQConfigReportItemIctYearsOutput = {
  __typename?: 'GetAvailableExamEventQConfigReportItemIctYearsOutput';
  ictExamYears: Array<Scalars['Int']['output']>;
};

export type GetExamCourseAnalysisReportFilterInput = {
  endedAt: Scalars['DateTime']['input'];
  examCenterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  examCourseCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  examCourseTypes: Array<ExamCourseType>;
  qConfigRefs?: InputMaybe<Array<Scalars['Int']['input']>>;
  startedAt: Scalars['DateTime']['input'];
};

export type GetExamCourseAnalysisReportInput = {
  filter: GetExamCourseAnalysisReportFilterInput;
  order?: InputMaybe<OrderInput>;
};

export type GetExamCourseAnalysisReportOutput = {
  __typename?: 'GetExamCourseAnalysisReportOutput';
  examCourseAnalysisReports: Array<ExamCourseAnalysisReportItem>;
};

export type GetLatestExamCourseAnalysisReportCreatedAtOutput = {
  __typename?: 'GetLatestExamCourseAnalysisReportCreatedAtOutput';
  latestCreatedAt: Scalars['DateTime']['output'];
};

export type GetLatestExamEventOverviewReportCreatedAtOutput = {
  __typename?: 'GetLatestExamEventOverviewReportCreatedAtOutput';
  latestCreatedAt: Scalars['DateTime']['output'];
};

export type GetLatestExamQSetUsageReportCreatedAtOutput = {
  __typename?: 'GetLatestExamQSetUsageReportCreatedAtOutput';
  latestCreatedAt: Scalars['DateTime']['output'];
};

export type GetLatestQuestionItemAnalysisReportCreatedAtOutput = {
  __typename?: 'GetLatestQuestionItemAnalysisReportCreatedAtOutput';
  latestCreatedAt: Scalars['DateTime']['output'];
};

export type GetLatestQuestionItemAnalysisYearlyReportCreatedAtOutput = {
  __typename?: 'GetLatestQuestionItemAnalysisYearlyReportCreatedAtOutput';
  latestCreatedAt: Scalars['DateTime']['output'];
};

export type GetLatestQuestionQSetUsageReportUpdatedAtOutput = {
  __typename?: 'GetLatestQuestionQSetUsageReportUpdatedAtOutput';
  latestUpdatedAt: Scalars['DateTime']['output'];
};

export type GetLongQuestionnaireSummaryReportInput = {
  endedAt: Scalars['DateTime']['input'];
  examCenterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  examCourseCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  startedAt: Scalars['DateTime']['input'];
};

export type GetMyExamCentersOutput = {
  __typename?: 'GetMyExamCentersOutput';
  examCenters: Array<ExamCenter>;
};

export type GetPAnalysisCellsInput = {
  endedAt: Scalars['DateTime']['input'];
  minimumExamineePerQuestion: Scalars['Int']['input'];
  pValueCustomThreshold: PValueThresholdInput;
  qBankStructureId: Scalars['String']['input'];
  questionStatus?: InputMaybe<Array<QuestionStatus>>;
  startedAt: Scalars['DateTime']['input'];
};

export type GetPAnalysisCellsOutput = {
  __typename?: 'GetPAnalysisCellsOutput';
  cells: Array<PAnalysisCell>;
  total: Scalars['Int']['output'];
};

export type GetQConfigRefCodesByExamCourseInput = {
  examCourseCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetQConfigRefCodesByExamCourseOutput = {
  __typename?: 'GetQConfigRefCodesByExamCourseOutput';
  qConfigRefCodes: Array<Scalars['Int']['output']>;
};

export type GetShortQuestionnaireSummaryReportInput = {
  endedAt: Scalars['DateTime']['input'];
  examCenterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  examCourseCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  startedAt: Scalars['DateTime']['input'];
};

export type GetStandardQuestionnaireSummaryReportInput = {
  endedAt: Scalars['DateTime']['input'];
  examCenterCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  examCourseCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  startedAt: Scalars['DateTime']['input'];
};

export type GetUserByIdOutputObjectType = {
  __typename?: 'GetUserByIdOutputObjectType';
  additional1: Maybe<Scalars['String']['output']>;
  additional2: Maybe<Scalars['String']['output']>;
  additional3: Maybe<Scalars['String']['output']>;
  additional4: Maybe<Scalars['String']['output']>;
  additional5: Maybe<Scalars['String']['output']>;
  additional6: Maybe<Scalars['String']['output']>;
  additional7: Maybe<Scalars['String']['output']>;
  additional8: Maybe<Scalars['String']['output']>;
  additional9: Maybe<Scalars['String']['output']>;
  additional10: Maybe<Scalars['String']['output']>;
  assignedAt: Maybe<Scalars['String']['output']>;
  assignedBy: Maybe<Scalars['JSON']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  status: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type Location = {
  __typename?: 'Location';
  id: Scalars['String']['output'];
  nameEn: Maybe<Scalars['String']['output']>;
  nameTh: Scalars['String']['output'];
  provinceId: Scalars['String']['output'];
};

export type LoginTwoFactorInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type LoginTwoFactorResponse = {
  __typename?: 'LoginTwoFactorResponse';
  code: Scalars['String']['output'];
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LogoutOutputObjectType = {
  __typename?: 'LogoutOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LongQuestionnaireReportMetrics = {
  __typename?: 'LongQuestionnaireReportMetrics';
  avgScore: Scalars['Float']['output'];
  count: Scalars['Float']['output'];
  fail: Scalars['Float']['output'];
  pass: Scalars['Float']['output'];
  passingRate: Scalars['Float']['output'];
};

export type LongQuestionnaireReportRow = {
  __typename?: 'LongQuestionnaireReportRow';
  inHouse: LongQuestionnaireReportMetrics;
  optionKey: Scalars['String']['output'];
  public: LongQuestionnaireReportMetrics;
  publicPlusInHouse: LongQuestionnaireReportMetrics;
};

export type LongQuestionnaireReportSection = {
  __typename?: 'LongQuestionnaireReportSection';
  rows: Array<LongQuestionnaireReportRow>;
  total: LongQuestionnaireReportRow;
};

export type LongQuestionnaireSummaryReportOutput = {
  __typename?: 'LongQuestionnaireSummaryReportOutput';
  age: LongQuestionnaireReportSection;
  currentOccupation: LongQuestionnaireReportSection;
  currentOrganization: LongQuestionnaireReportSection;
  examAttempted: LongQuestionnaireReportSection;
  examAttendingObjectives: LongQuestionnaireReportSection;
  examDevice: LongQuestionnaireReportSection;
  examPreparations: LongQuestionnaireReportSection;
  examProvince: LongQuestionnaireReportSection;
  examReadiness: LongQuestionnaireReportSection;
  highestEducationLevel: LongQuestionnaireReportSection;
  locationSatisfaction: LongQuestionnaireReportSection;
  major: LongQuestionnaireReportSection;
  referralSource: LongQuestionnaireReportSection;
  staffServicesSatisfaction: LongQuestionnaireReportSection;
  systemStabilitySatisfaction: LongQuestionnaireReportSection;
  systemUsabilitySatisfaction: LongQuestionnaireReportSection;
  workExperience: LongQuestionnaireReportSection;
};

export type Mutation = {
  __typename?: 'Mutation';
  assignUserAppRoles: AssignUserAppRolesMutationResponse;
  reportAdjustQuestionsPValues: AdjustQuestionsPValuesOutput;
  reportExportQuestionnaireSummaryReport: ExportQuestionnaireSummaryReportOutput;
  suAcceptResetPassword: AcceptResetPasswordOutputObjectType;
  suAssignUserAppRole: AssignUserAppRoleMutationResponse;
  suClearSession: ClearSessionOutputObjectType;
  suCreateAppRole: CreateAppRoleMutationResponse;
  suDeleteAppRole: DeleteAppRoleMutationResponse;
  suGenerateTwoFactorSecret: GenerateTwoFactorSecretOutputObjectType;
  suLoginTwoFactor: LoginTwoFactorResponse;
  suLogout: LogoutOutputObjectType;
  suQuickCreateUser: QuickCreateUserObjectType;
  suResendResetPasswordEmail: ResendResetPasswordEmailOutputObjectType;
  suResendResetPasswordUserLocked: ResendResetPasswordUserLockedOutputObjectType;
  suResetPassword: ResetPasswordOutputObjectType;
  suResetUserTwoFactor: ResetUserTwoFactorOutputObjectType;
  suUnassignUserAppRoles: UnassignUserAppRolesMutationResponse;
  suUnlockUserTwoFactor: UnlockUserTwoFactorOutputObjectType;
  suUpdateAppRole: UpdateAppRoleMutationResponse;
  suUpdateAppRoleAppPermissions: UpdateAppRoleAppPermissionsMutationResponse;
  suUpdateUser: UpdateUserOutputObjectType;
  suUpdateUserStatus: UpdateUserStatusOutputObjectType;
  suVerifyUserTwoFactor: VerifyUserTwoFactorOutputObjectType;
  unassignUserAppRole: AssignUserAppRoleMutationResponse;
  updateUserAppRoleByNames: UpdateUserAppRoleByNameMutationResponse;
  updateUserAppRoles: UpdateUserAppRolesMutationResponse;
};


export type MutationAssignUserAppRolesArgs = {
  data: AssignUserAppRolesInput;
};


export type MutationReportAdjustQuestionsPValuesArgs = {
  adjustQuestionsPValuesInput: AdjustQuestionsPValuesInput;
};


export type MutationReportExportQuestionnaireSummaryReportArgs = {
  input: ExportQuestionnaireSummaryReportInput;
};


export type MutationSuAcceptResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSuAssignUserAppRoleArgs = {
  data: AssignUserAppRoleInput;
};


export type MutationSuCreateAppRoleArgs = {
  data: CreateAppRoleInput;
};


export type MutationSuDeleteAppRoleArgs = {
  data: DeleteAppRoleInput;
};


export type MutationSuLoginTwoFactorArgs = {
  LoginTwoFactorInput: LoginTwoFactorInput;
};


export type MutationSuQuickCreateUserArgs = {
  appRoleIds: InputMaybe<AppRoleIdsInput>;
  quickCreateInput: QuickCreateInput;
};


export type MutationSuResendResetPasswordEmailArgs = {
  userId: Scalars['String']['input'];
};


export type MutationSuResendResetPasswordUserLockedArgs = {
  email: Scalars['String']['input'];
};


export type MutationSuResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationSuResetUserTwoFactorArgs = {
  data: ResetUserTwoFactorInput;
};


export type MutationSuUnassignUserAppRolesArgs = {
  data: UnassignUserAppRolesInput;
};


export type MutationSuUnlockUserTwoFactorArgs = {
  data: UnlockUserTwoFactorInput;
};


export type MutationSuUpdateAppRoleArgs = {
  data: UpdateAppRoleInput;
};


export type MutationSuUpdateAppRoleAppPermissionsArgs = {
  appPermissionIds: Array<Scalars['String']['input']>;
  appRoleId: Scalars['String']['input'];
};


export type MutationSuUpdateUserArgs = {
  data: UpdateUserInput;
  userId: Scalars['String']['input'];
};


export type MutationSuUpdateUserStatusArgs = {
  data: UpdateUserStatusInput;
};


export type MutationSuVerifyUserTwoFactorArgs = {
  input: VerifyUserTwoFactorInput;
};


export type MutationUnassignUserAppRoleArgs = {
  data: UnassignUserAppRoleInput;
};


export type MutationUpdateUserAppRoleByNamesArgs = {
  data: UpdateUserAppRoleByNamesInput;
};


export type MutationUpdateUserAppRolesArgs = {
  data: UpdateUserAppRolesInput;
};

export enum OperatorType {
  And = 'AND',
  Or = 'OR'
}

export type OrderInput = {
  /** Field to order by */
  field: Scalars['String']['input'];
  type: OrderType;
};

export enum OrderType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PAnalysisCell = {
  __typename?: 'PAnalysisCell';
  pCalculatedWithThresholdDifficulty: QuestionDifficulty;
  pUsedDifficulty: QuestionDifficulty;
  totalQuestions: Scalars['Int']['output'];
};

export type PValueRangeInput = {
  max: Scalars['Float']['input'];
  min: Scalars['Float']['input'];
};

export type PValueThresholdInput = {
  easy: PValueRangeInput;
  hard: PValueRangeInput;
  medium: PValueRangeInput;
};

export type PageInput = {
  currentPage: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type PagingInput = {
  currentPage: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type PercentageOfAnswered = {
  __typename?: 'PercentageOfAnswered';
  answer: Scalars['String']['output'];
  total: Maybe<Scalars['Float']['output']>;
};

export type PercentageValueWithRegisteredType = {
  __typename?: 'PercentageValueWithRegisteredType';
  inHouse: Maybe<Scalars['Float']['output']>;
  public: Maybe<Scalars['Float']['output']>;
  total: Maybe<Scalars['Float']['output']>;
};

export type Province = {
  __typename?: 'Province';
  code: Scalars['String']['output'];
  geographyId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  nameEn: Scalars['String']['output'];
  nameTh: Scalars['String']['output'];
};

export type QBankStructure = {
  __typename?: 'QBankStructure';
  code: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum QBankStructureStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export enum QSetStatus {
  Disabled = 'DISABLED',
  Published = 'PUBLISHED'
}

export type QSetUsage = {
  __typename?: 'QSetUsage';
  isUsed: Scalars['Boolean']['output'];
  qSetCodeNumber: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  UsBoGetTokenStatus: UsBoGetTokenStatusResponse;
  UsBoSearchUsersWithAppRoleFilters: UsBoUserSearchResult;
  UsBoUser: UsBoUser;
  UsBoUsers: UsBoUserSearchResult;
  getAppPermissions: Array<AppPermission>;
  getAppRoleAppPermissions: Array<AppPermission>;
  getAppRoles: AppRoleSearchResult;
  getMyProfile: UsUser;
  getUserAppRoleView: UserAppRoleViewSearchResult;
  reportCountExamEventReportItemSummary: CountExamEventReportItemSummaryOutput;
  reportExportExamCourseAnalysisReport: ExportExamCourseAnalysisReportOutput;
  reportExportExamEventReportItems: ExportExamEventReportItemsOutput;
  reportExportExamQSetUsageRecords: ExportExamQSetUsageRecordsOutput;
  reportExportQuestionItemAnalysisRecords: ExportQuestionItemAnalysisRecordsOutput;
  reportExportQuestionItemAnalysisYearlyRecords: ExportQuestionItemAnalysisYearlyRecordsOutput;
  reportExportQuestionQSetUsageRecords: ExportQuestionQSetUsageRecordsOutput;
  reportGetAllExamCenters: GetAllExamCentersOutput;
  reportGetAllExamCourses: GetAllExamCoursesOutput;
  reportGetAllProvinces: GetAllProvincesOutput;
  reportGetAllQBankStructures: GetAllQBankStructuresOutput;
  reportGetAvailableExamEventQConfigReportItemIctYears: GetAvailableExamEventQConfigReportItemIctYearsOutput;
  reportGetExamCourseAnalysisReport: GetExamCourseAnalysisReportOutput;
  reportGetLatestExamCourseAnalysisReportCreatedAt: GetLatestExamCourseAnalysisReportCreatedAtOutput;
  reportGetLatestExamEventOverviewReportCreatedAt: GetLatestExamEventOverviewReportCreatedAtOutput;
  reportGetLatestExamQSetUsageReportCreatedAt: GetLatestExamQSetUsageReportCreatedAtOutput;
  reportGetLatestQuestionItemAnalysisReportCreatedAt: GetLatestQuestionItemAnalysisReportCreatedAtOutput;
  reportGetLatestQuestionItemAnalysisYearlyReportCreatedAt: GetLatestQuestionItemAnalysisYearlyReportCreatedAtOutput;
  reportGetLatestQuestionQSetUsageReportUpdatedAt: GetLatestQuestionQSetUsageReportUpdatedAtOutput;
  reportGetLongQuestionnaireSummaryReport: LongQuestionnaireSummaryReportOutput;
  reportGetMyExamCenters: GetMyExamCentersOutput;
  reportGetPAnalysisCells: GetPAnalysisCellsOutput;
  reportGetQConfigRefCodesByExamCourse: GetQConfigRefCodesByExamCourseOutput;
  reportGetShortQuestionnaireSummaryReport: ShortQuestionnaireSummaryReportOutput;
  reportGetStandardQuestionnaireSummaryReport: StandardQuestionnaireSummaryReportOutput;
  reportSearchExamEventReportItems: SearchExamEventReportItemsOutput;
  reportSearchExamQSetUsageRecords: SearchExamQSetUsageRecordsOutput;
  reportSearchQuestionItemAnalysisRecords: SearchQuestionItemAnalysisRecordsOutput;
  reportSearchQuestionItemAnalysisYearlyRecords: SearchQuestionItemAnalysisYearlyRecordsOutput;
  reportSearchQuestionQSetUsageRecords: SearchQuestionQSetUsageRecordsOutput;
  suGetAppRole: GetAppRoleOutputObjectType;
  suUser: GetUserByIdOutputObjectType;
  validateToken: ValidateTokenResult;
};


export type QueryUsBoSearchUsersWithAppRoleFiltersArgs = {
  appRoleIds: InputMaybe<Array<Scalars['String']['input']>>;
  appRoleNames: InputMaybe<Array<Scalars['String']['input']>>;
  excludeAppRoleIds: InputMaybe<Array<Scalars['String']['input']>>;
  excludeFields: InputMaybe<UsBoUserExcludeFieldsInput>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PageInput>;
  search?: InputMaybe<UsBoUserSearchInput>;
};


export type QueryUsBoUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUsBoUsersArgs = {
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PageInput>;
  search: InputMaybe<UsBoUserSearchInput>;
};


export type QueryGetAppRoleAppPermissionsArgs = {
  appRoleId: Scalars['String']['input'];
};


export type QueryGetAppRolesArgs = {
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PageInput>;
  search: InputMaybe<AppRoleSearchInput>;
};


export type QueryGetUserAppRoleViewArgs = {
  appRoleId: InputMaybe<Scalars['String']['input']>;
  invertRoleFilter?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PageInput>;
  search?: InputMaybe<SearchInput>;
};


export type QueryReportCountExamEventReportItemSummaryArgs = {
  countExamEventReportItemSummaryInput: CountExamEventReportItemSummaryInput;
};


export type QueryReportExportExamCourseAnalysisReportArgs = {
  exportExamCourseAnalysisReportInput: ExportExamCourseAnalysisReportInput;
};


export type QueryReportExportExamEventReportItemsArgs = {
  exportExamEventReportItemsInput: ExportExamEventReportItemsInput;
};


export type QueryReportExportExamQSetUsageRecordsArgs = {
  exportExamQSetUsageRecordsInput: ExportExamQSetUsageRecordsInput;
};


export type QueryReportExportQuestionItemAnalysisRecordsArgs = {
  exportQuestionItemAnalysisRecordsInput: ExportQuestionItemAnalysisRecordsInput;
};


export type QueryReportExportQuestionItemAnalysisYearlyRecordsArgs = {
  exportQuestionItemAnalysisYearlyRecordsInput: ExportQuestionItemAnalysisYearlyRecordsInput;
};


export type QueryReportExportQuestionQSetUsageRecordsArgs = {
  exportQuestionQSetUsageRecordsInput: ExportQuestionQSetUsageRecordsInput;
};


export type QueryReportGetAllQBankStructuresArgs = {
  GetAllQBankStructuresInput: GetAllQBankStructuresInput;
};


export type QueryReportGetExamCourseAnalysisReportArgs = {
  getExamCourseAnalysisReportInput: GetExamCourseAnalysisReportInput;
};


export type QueryReportGetLongQuestionnaireSummaryReportArgs = {
  input: GetLongQuestionnaireSummaryReportInput;
};


export type QueryReportGetPAnalysisCellsArgs = {
  getPAnalysisCellsInput: GetPAnalysisCellsInput;
};


export type QueryReportGetQConfigRefCodesByExamCourseArgs = {
  getQConfigRefCodesByExamCourseInput: GetQConfigRefCodesByExamCourseInput;
};


export type QueryReportGetShortQuestionnaireSummaryReportArgs = {
  input: GetShortQuestionnaireSummaryReportInput;
};


export type QueryReportGetStandardQuestionnaireSummaryReportArgs = {
  input: GetStandardQuestionnaireSummaryReportInput;
};


export type QueryReportSearchExamEventReportItemsArgs = {
  searchExamEventReportItemsInput: SearchExamEventReportItemsInput;
};


export type QueryReportSearchExamQSetUsageRecordsArgs = {
  searchExamQSetUsageRecordsInput: SearchExamQSetUsageRecordsInput;
};


export type QueryReportSearchQuestionItemAnalysisRecordsArgs = {
  searchQuestionItemAnalysisRecordsInput: SearchQuestionItemAnalysisRecordsInput;
};


export type QueryReportSearchQuestionItemAnalysisYearlyRecordsArgs = {
  searchQuestionItemAnalysisYearlyRecordsInput: SearchQuestionItemAnalysisYearlyRecordsInput;
};


export type QueryReportSearchQuestionQSetUsageRecordsArgs = {
  searchQuestionQSetUsageRecordsInput: SearchQuestionQSetUsageRecordsInput;
};


export type QuerySuGetAppRoleArgs = {
  appRoleId: Scalars['String']['input'];
};


export type QuerySuUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryValidateTokenArgs = {
  token: Scalars['String']['input'];
};

export enum QuestionDifficulty {
  Easy = 'EASY',
  Hard = 'HARD',
  Medium = 'MEDIUM'
}

export type QuestionItemAnalysisRecord = {
  __typename?: 'QuestionItemAnalysisRecord';
  answer: Scalars['String']['output'];
  bIndex: Scalars['Float']['output'];
  bIndexInitial: Maybe<Scalars['Float']['output']>;
  calculated: Scalars['Boolean']['output'];
  firstPublishedAt: Scalars['DateTime']['output'];
  lastPublishedAt: Scalars['DateTime']['output'];
  numbersOfExaminees: Array<AnswerCount>;
  numbersOfFailed: Array<AnswerCount>;
  numbersOfPassed: Array<AnswerCount>;
  pCalculated: Maybe<Scalars['Float']['output']>;
  pInitial: Scalars['Float']['output'];
  pUse: Scalars['Float']['output'];
  percentageOfAnswered: Array<PercentageOfAnswered>;
  questionId: Scalars['String']['output'];
  questionRefCode: Scalars['String']['output'];
  status: QuestionStatus;
  totalExaminees: Scalars['Int']['output'];
  totalNumberOfFailed: Scalars['Int']['output'];
  totalNumberOfPassed: Scalars['Int']['output'];
};

export type QuestionItemAnalysisYearlyRecord = {
  __typename?: 'QuestionItemAnalysisYearlyRecord';
  bIndexInitial: Maybe<Scalars['Float']['output']>;
  calculated: Scalars['Boolean']['output'];
  firstPublishedAt: Scalars['DateTime']['output'];
  lastPublishedAt: Scalars['DateTime']['output'];
  pInitial: Scalars['Float']['output'];
  pUsed: Scalars['Float']['output'];
  questionId: Scalars['String']['output'];
  questionRefCode: Scalars['String']['output'];
  status: QuestionStatus;
  summaryQuestionItem: SummaryQuestionItem;
  yearlyQuestionItems: Array<YearlyQuestionItem>;
};

export type QuestionQSetUsageRecord = {
  __typename?: 'QuestionQSetUsageRecord';
  bIndexInitial: Maybe<Scalars['Float']['output']>;
  calculated: Scalars['Boolean']['output'];
  pInitial: Scalars['Float']['output'];
  pUsed: Scalars['Float']['output'];
  qSetUsages: Array<QSetUsage>;
  questionId: Scalars['String']['output'];
  questionRefCode: Scalars['String']['output'];
};

export enum QuestionStatus {
  Disabled = 'DISABLED',
  Published = 'PUBLISHED'
}

export enum QuestionnaireTemplate {
  LongForm = 'LONG_FORM',
  ShortForm = 'SHORT_FORM',
  Standard = 'STANDARD'
}

export type QuickCreateInput = {
  blockedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  expireAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstName: Scalars['String']['input'];
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QuickCreateUserObjectType = {
  __typename?: 'QuickCreateUserObjectType';
  appRolesResponse: AssignUserAppRolesMutationResponse;
  code: Scalars['String']['output'];
  createdUser: UserAppRoleView;
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RegisteredTypeValue = {
  __typename?: 'RegisteredTypeValue';
  inHouse: Scalars['Int']['output'];
  public: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum RegistrationType {
  InHouse = 'IN_HOUSE',
  Public = 'PUBLIC'
}

export type ResendResetPasswordEmailOutputObjectType = {
  __typename?: 'ResendResetPasswordEmailOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResendResetPasswordUserLockedOutputObjectType = {
  __typename?: 'ResendResetPasswordUserLockedOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResetPasswordOutputObjectType = {
  __typename?: 'ResetPasswordOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResetUserTwoFactorInput = {
  reason: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ResetUserTwoFactorOutputObjectType = {
  __typename?: 'ResetUserTwoFactorOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  user: UserAppRoleView;
};

export type SearchExamEventReportItemsInput = {
  filter: ExamEventReportItemFilterInput;
  order?: InputMaybe<OrderInput>;
  paging?: InputMaybe<PagingInput>;
};

export type SearchExamEventReportItemsOutput = {
  __typename?: 'SearchExamEventReportItemsOutput';
  examEventReportItems: Array<ExamEventReportItem>;
  total: Scalars['Float']['output'];
};

export type SearchExamQSetUsageFilterInput = {
  endedAt: Scalars['DateTime']['input'];
  examCourseId: Scalars['String']['input'];
  startedAt: Scalars['DateTime']['input'];
};

export type SearchExamQSetUsageRecordsInput = {
  filter: SearchExamQSetUsageFilterInput;
  paging: SearchPagingInput;
};

export type SearchExamQSetUsageRecordsOutput = {
  __typename?: 'SearchExamQSetUsageRecordsOutput';
  records: Array<ExamQSetUsageRecord>;
  total: Scalars['Int']['output'];
};

export type SearchInput = {
  operator: OperatorType;
  value: Scalars['String']['input'];
};

export type SearchPagingInput = {
  currentPage: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type SearchQuestionItemAnalysisRecordsInput = {
  endAt: Scalars['DateTime']['input'];
  knowledgeGroup: BIndexThreshold;
  minimumExamineePerQuestion: Scalars['Int']['input'];
  nonKnowledgeGroup: BIndexThreshold;
  paging: SearchPagingInput;
  qBankStructureId: Scalars['String']['input'];
  questionStatus?: InputMaybe<Array<QuestionStatus>>;
  startAt: Scalars['DateTime']['input'];
};

export type SearchQuestionItemAnalysisRecordsOutput = {
  __typename?: 'SearchQuestionItemAnalysisRecordsOutput';
  records: Array<QuestionItemAnalysisRecord>;
  total: Scalars['Int']['output'];
};

export type SearchQuestionItemAnalysisYearlyRecordsInput = {
  endedAt: Scalars['DateTime']['input'];
  knowledgeGroup: BIndexThreshold;
  minimumExamineePerQuestion: Scalars['Int']['input'];
  nonKnowledgeGroup: BIndexThreshold;
  paging: SearchPagingInput;
  qBankStructureId: Scalars['String']['input'];
  questionStatus?: InputMaybe<Array<QuestionStatus>>;
  startedAt: Scalars['DateTime']['input'];
};

export type SearchQuestionItemAnalysisYearlyRecordsOutput = {
  __typename?: 'SearchQuestionItemAnalysisYearlyRecordsOutput';
  records: Array<QuestionItemAnalysisYearlyRecord>;
  total: Scalars['Int']['output'];
};

export type SearchQuestionQSetUsageRecordsInput = {
  examCourseId: Scalars['String']['input'];
  paging: SearchPagingInput;
  qSetStatuses?: InputMaybe<Array<QSetStatus>>;
};

export type SearchQuestionQSetUsageRecordsOutput = {
  __typename?: 'SearchQuestionQSetUsageRecordsOutput';
  records: Array<QuestionQSetUsageRecord>;
  total: Scalars['Int']['output'];
};

export type ShortQuestionnaireReportMetrics = {
  __typename?: 'ShortQuestionnaireReportMetrics';
  avgScore: Scalars['Float']['output'];
  count: Scalars['Float']['output'];
  fail: Scalars['Float']['output'];
  pass: Scalars['Float']['output'];
  passingRate: Scalars['Float']['output'];
};

export type ShortQuestionnaireReportRow = {
  __typename?: 'ShortQuestionnaireReportRow';
  inHouse: ShortQuestionnaireReportMetrics;
  optionKey: Scalars['String']['output'];
  public: ShortQuestionnaireReportMetrics;
  publicPlusInHouse: ShortQuestionnaireReportMetrics;
};

export type ShortQuestionnaireReportSection = {
  __typename?: 'ShortQuestionnaireReportSection';
  rows: Array<ShortQuestionnaireReportRow>;
  total: ShortQuestionnaireReportRow;
};

export type ShortQuestionnaireSummaryReportOutput = {
  __typename?: 'ShortQuestionnaireSummaryReportOutput';
  age: ShortQuestionnaireReportSection;
  currentOrganization: ShortQuestionnaireReportSection;
  examAttendingObjectives: ShortQuestionnaireReportSection;
  highestEducationLevel: ShortQuestionnaireReportSection;
  locationSatisfaction: ShortQuestionnaireReportSection;
  staffServicesSatisfaction: ShortQuestionnaireReportSection;
  systemStabilitySatisfaction: ShortQuestionnaireReportSection;
  systemUsabilitySatisfaction: ShortQuestionnaireReportSection;
};

export type StandardQuestionnaireReportMetrics = {
  __typename?: 'StandardQuestionnaireReportMetrics';
  avgScore: Scalars['Float']['output'];
  count: Scalars['Float']['output'];
  fail: Scalars['Float']['output'];
  pass: Scalars['Float']['output'];
  passingRate: Scalars['Float']['output'];
};

export type StandardQuestionnaireReportRow = {
  __typename?: 'StandardQuestionnaireReportRow';
  inHouse: StandardQuestionnaireReportMetrics;
  optionKey: Scalars['String']['output'];
  public: StandardQuestionnaireReportMetrics;
  publicPlusInHouse: StandardQuestionnaireReportMetrics;
};

export type StandardQuestionnaireReportSection = {
  __typename?: 'StandardQuestionnaireReportSection';
  rows: Array<StandardQuestionnaireReportRow>;
  total: StandardQuestionnaireReportRow;
};

export type StandardQuestionnaireSummaryReportOutput = {
  __typename?: 'StandardQuestionnaireSummaryReportOutput';
  age: StandardQuestionnaireReportSection;
  currentOrganization: StandardQuestionnaireReportSection;
  examAttempted: StandardQuestionnaireReportSection;
  examAttendingObjectives: StandardQuestionnaireReportSection;
  examPreparations: StandardQuestionnaireReportSection;
  highestEducationLevel: StandardQuestionnaireReportSection;
  locationSatisfaction: StandardQuestionnaireReportSection;
  major: StandardQuestionnaireReportSection;
  staffServicesSatisfaction: StandardQuestionnaireReportSection;
  systemStabilitySatisfaction: StandardQuestionnaireReportSection;
  systemUsabilitySatisfaction: StandardQuestionnaireReportSection;
  workExperience: StandardQuestionnaireReportSection;
};

export type SummaryQuestionItem = {
  __typename?: 'SummaryQuestionItem';
  bIndex: Scalars['Float']['output'];
  pCalculated: Maybe<Scalars['Float']['output']>;
  totalExaminees: Scalars['Int']['output'];
};

export type TokenStatus = {
  __typename?: 'TokenStatus';
  email: Maybe<Scalars['String']['output']>;
  scopes: Maybe<Array<Scalars['String']['output']>>;
  ttl: Maybe<Scalars['Float']['output']>;
  twoFactorStatus: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export type UnassignUserAppRoleInput = {
  appRoleId: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UnassignUserAppRolesInput = {
  appRoleIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UnassignUserAppRolesMutationResponse = {
  __typename?: 'UnassignUserAppRolesMutationResponse';
  appRoles: Array<AppRole>;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UnlockUserTwoFactorInput = {
  reason: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UnlockUserTwoFactorOutputObjectType = {
  __typename?: 'UnlockUserTwoFactorOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  user: UserAppRoleView;
};

export type UpdateAppRoleAppPermissionsMutationResponse = {
  __typename?: 'UpdateAppRoleAppPermissionsMutationResponse';
  appPermission: Array<AppPermission>;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateAppRoleInput = {
  appRoleId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateAppRoleMutationResponse = {
  __typename?: 'UpdateAppRoleMutationResponse';
  appRole: AppRole;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserAppRoleByNameMutationResponse = {
  __typename?: 'UpdateUserAppRoleByNameMutationResponse';
  appRoles: Maybe<Array<AppRole>>;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserAppRoleByNamesInput = {
  appRoleNames: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UpdateUserAppRolesInput = {
  appRoleIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UpdateUserAppRolesMutationResponse = {
  __typename?: 'UpdateUserAppRolesMutationResponse';
  appRoles: Maybe<Array<AppRole>>;
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserInput = {
  appRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  organizationInfo?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateUserOutputObjectType = {
  __typename?: 'UpdateUserOutputObjectType';
  additional1: Maybe<Scalars['String']['output']>;
  additional2: Maybe<Scalars['String']['output']>;
  additional3: Maybe<Scalars['String']['output']>;
  additional4: Maybe<Scalars['String']['output']>;
  additional5: Maybe<Scalars['String']['output']>;
  additional6: Maybe<Scalars['String']['output']>;
  additional7: Maybe<Scalars['String']['output']>;
  additional8: Maybe<Scalars['String']['output']>;
  additional9: Maybe<Scalars['String']['output']>;
  additional10: Maybe<Scalars['String']['output']>;
  assignedAt: Maybe<Scalars['String']['output']>;
  assignedBy: Maybe<Scalars['JSON']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  status: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type UpdateUserStatusInput = {
  status: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateUserStatusOutputObjectType = {
  __typename?: 'UpdateUserStatusOutputObjectType';
  code: Scalars['String']['output'];
  details: Maybe<Scalars['JSON']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  updatedUser: UserAppRoleView;
};

export type UsBoGetTokenStatusResponse = {
  __typename?: 'UsBoGetTokenStatusResponse';
  result: TokenStatus;
};

export type UsBoUser = {
  __typename?: 'UsBoUser';
  additional1: Maybe<Scalars['String']['output']>;
  additional2: Maybe<Scalars['String']['output']>;
  additional3: Maybe<Scalars['String']['output']>;
  additional4: Maybe<Scalars['String']['output']>;
  additional5: Maybe<Scalars['String']['output']>;
  additional6: Maybe<Scalars['String']['output']>;
  additional7: Maybe<Scalars['String']['output']>;
  additional8: Maybe<Scalars['String']['output']>;
  additional9: Maybe<Scalars['String']['output']>;
  additional10: Maybe<Scalars['String']['output']>;
  appPermissions: Array<Scalars['String']['output']>;
  appRoles: Array<Scalars['String']['output']>;
  blockedUntil: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  expireAt: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  isDisabled: Maybe<Scalars['Boolean']['output']>;
  isPassportUser: Scalars['Boolean']['output'];
  isPasswordCreatedByUser: Maybe<Scalars['Boolean']['output']>;
  isVerified: Maybe<Scalars['Boolean']['output']>;
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  newEmail: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['String']['output']>;
  organizationInfo: Maybe<Scalars['JSON']['output']>;
  realm: Maybe<Scalars['String']['output']>;
  referenceId: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  teamIds: Array<Scalars['String']['output']>;
  twoFactorStatus: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['String']['output']>;
  updatedBy: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type UsBoUserExcludeFieldsInput = {
  additional1?: InputMaybe<Array<Scalars['String']['input']>>;
  additional2?: InputMaybe<Array<Scalars['String']['input']>>;
  additional3?: InputMaybe<Array<Scalars['String']['input']>>;
  additional4?: InputMaybe<Array<Scalars['String']['input']>>;
  additional5?: InputMaybe<Array<Scalars['String']['input']>>;
  additional6?: InputMaybe<Array<Scalars['String']['input']>>;
  additional7?: InputMaybe<Array<Scalars['String']['input']>>;
  additional8?: InputMaybe<Array<Scalars['String']['input']>>;
  additional9?: InputMaybe<Array<Scalars['String']['input']>>;
  additional10?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  firstname?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Array<Scalars['String']['input']>>;
  lastname?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceId?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UsBoUserSearchInput = {
  additional1?: InputMaybe<Scalars['String']['input']>;
  additional2?: InputMaybe<Scalars['String']['input']>;
  additional3?: InputMaybe<Scalars['String']['input']>;
  additional4?: InputMaybe<Scalars['String']['input']>;
  additional5?: InputMaybe<Scalars['String']['input']>;
  additional6?: InputMaybe<Scalars['String']['input']>;
  additional7?: InputMaybe<Scalars['String']['input']>;
  additional8?: InputMaybe<Scalars['String']['input']>;
  additional9?: InputMaybe<Scalars['String']['input']>;
  additional10?: InputMaybe<Scalars['String']['input']>;
  blockedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expireAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsBoUserSearchResult = {
  __typename?: 'UsBoUserSearchResult';
  total: Scalars['Int']['output'];
  users: Array<UsBoUser>;
};

export type UsUser = {
  __typename?: 'UsUser';
  additional1: Maybe<Scalars['String']['output']>;
  additional2: Maybe<Scalars['String']['output']>;
  additional3: Maybe<Scalars['String']['output']>;
  additional4: Maybe<Scalars['String']['output']>;
  additional5: Maybe<Scalars['String']['output']>;
  additional6: Maybe<Scalars['String']['output']>;
  additional7: Maybe<Scalars['String']['output']>;
  additional8: Maybe<Scalars['String']['output']>;
  additional9: Maybe<Scalars['String']['output']>;
  additional10: Maybe<Scalars['String']['output']>;
  appPermissions: Array<Scalars['String']['output']>;
  appRoles: Array<Scalars['String']['output']>;
  blockedUntil: Maybe<Scalars['DateTime']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  emailVerified: Maybe<Scalars['Boolean']['output']>;
  expireAt: Maybe<Scalars['DateTime']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Maybe<Scalars['String']['output']>;
  isAdmin: Maybe<Scalars['Boolean']['output']>;
  isDisabled: Maybe<Scalars['Boolean']['output']>;
  isPassportUser: Scalars['Boolean']['output'];
  isPasswordCreatedByUser: Maybe<Scalars['Boolean']['output']>;
  isVerified: Maybe<Scalars['Boolean']['output']>;
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  newEmail: Maybe<Scalars['String']['output']>;
  organizationId: Maybe<Scalars['String']['output']>;
  organizationInfo: Maybe<Scalars['JSON']['output']>;
  realm: Maybe<Scalars['String']['output']>;
  referenceId: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  teamIds: Array<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type UserAppRoleView = {
  __typename?: 'UserAppRoleView';
  additional1: Maybe<Scalars['String']['output']>;
  additional2: Maybe<Scalars['String']['output']>;
  additional3: Maybe<Scalars['String']['output']>;
  additional4: Maybe<Scalars['String']['output']>;
  additional5: Maybe<Scalars['String']['output']>;
  additional6: Maybe<Scalars['String']['output']>;
  additional7: Maybe<Scalars['String']['output']>;
  additional8: Maybe<Scalars['String']['output']>;
  additional9: Maybe<Scalars['String']['output']>;
  additional10: Maybe<Scalars['String']['output']>;
  assignedAt: Maybe<Scalars['String']['output']>;
  assignedBy: Maybe<Scalars['JSON']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitationExpireAt: Maybe<Scalars['String']['output']>;
  lastLoginAt: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  status: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type UserAppRoleViewSearchResult = {
  __typename?: 'UserAppRoleViewSearchResult';
  total: Scalars['Int']['output'];
  users: Array<UserAppRoleView>;
};

export type ValidateTokenResult = {
  __typename?: 'ValidateTokenResult';
  description: Maybe<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
};

export type VerifyUserTwoFactorInput = {
  code: Scalars['String']['input'];
};

export type VerifyUserTwoFactorOutputObjectType = {
  __typename?: 'VerifyUserTwoFactorOutputObjectType';
  code: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type YearlyQuestionItem = {
  __typename?: 'YearlyQuestionItem';
  bIndex: Scalars['Float']['output'];
  pCalculated: Maybe<Scalars['Float']['output']>;
  totalExaminees: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type GetMyExamCentersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyExamCentersQuery = { __typename?: 'Query', reportGetMyExamCenters: { __typename?: 'GetMyExamCentersOutput', examCenters: Array<{ __typename?: 'ExamCenter', code: string, examCenterId: number }> } };

export type GetAllExamCentersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllExamCentersQuery = { __typename?: 'Query', reportGetAllExamCenters: { __typename?: 'GetAllExamCentersOutput', examCenters: Array<{ __typename?: 'ExamCenter', id: string, nameTh: string, code: string }> } };

export type GetExamCourseAnalysisReportQueryVariables = Exact<{
  getExamCourseAnalysisReportInput: GetExamCourseAnalysisReportInput;
}>;


export type GetExamCourseAnalysisReportQuery = { __typename?: 'Query', reportGetExamCourseAnalysisReport: { __typename?: 'GetExamCourseAnalysisReportOutput', examCourseAnalysisReports: Array<{ __typename?: 'ExamCourseAnalysisReportItem', id: string, examId: number, examCourseCode: string, examCourseType: ExamCourseType, qConfigRef: number, fullScore: number, standardDeviationScore: number, maxScore: number, minScore: number, averageScore: number, uniqueExamineeCount: number, avgAttempts: number | null, applicantExamineeCount: { __typename?: 'RegisteredTypeValue', inHouse: number, public: number, total: number }, attendedExamineeCount: { __typename?: 'RegisteredTypeValue', inHouse: number, public: number, total: number }, passedExamineeCount: { __typename?: 'RegisteredTypeValue', inHouse: number, public: number, total: number }, failedExamineeCount: { __typename?: 'RegisteredTypeValue', inHouse: number, public: number, total: number }, passedRate: { __typename?: 'PercentageValueWithRegisteredType', inHouse: number | null, public: number | null, total: number | null }, examCourse: { __typename?: 'ExamCourse', id: string, code: string, name: string, examId: number } | null }> } };

export type GetLatestExamCourseAnalysisReportCreatedAtQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestExamCourseAnalysisReportCreatedAtQuery = { __typename?: 'Query', reportGetLatestExamCourseAnalysisReportCreatedAt: { __typename?: 'GetLatestExamCourseAnalysisReportCreatedAtOutput', latestCreatedAt: Date } };

export type ExportReportExportExamCourseAnalysisReportQueryVariables = Exact<{
  exportExamCourseAnalysisReportInput: ExportExamCourseAnalysisReportInput;
}>;


export type ExportReportExportExamCourseAnalysisReportQuery = { __typename?: 'Query', reportExportExamCourseAnalysisReport: { __typename?: 'ExportExamCourseAnalysisReportOutput', signedUrl: string } };

export type GetAllExamCoursesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllExamCoursesQuery = { __typename?: 'Query', reportGetAllExamCourses: { __typename?: 'GetAllExamCoursesOutput', examCourses: Array<{ __typename?: 'ExamCourse', code: string, id: string }> } };

export type GetQConfigRefCodesByExamCourseQueryVariables = Exact<{
  getQConfigRefCodesByExamCourseInput: GetQConfigRefCodesByExamCourseInput;
}>;


export type GetQConfigRefCodesByExamCourseQuery = { __typename?: 'Query', reportGetQConfigRefCodesByExamCourse: { __typename?: 'GetQConfigRefCodesByExamCourseOutput', qConfigRefCodes: Array<number> } };

export type SearchExamEventReportItemsQueryVariables = Exact<{
  searchExamEventReportItemsInput: SearchExamEventReportItemsInput;
}>;


export type SearchExamEventReportItemsQuery = { __typename?: 'Query', reportSearchExamEventReportItems: { __typename?: 'SearchExamEventReportItemsOutput', total: number, examEventReportItems: Array<{ __typename?: 'ExamEventReportItem', id: string, startedAt: Date, endedAt: Date, examCenterCode: string, registrationType: RegistrationType, examType: ExamType, seatCount: number, examineeCount: number, attendedExamineeCount: number, location: { __typename?: 'Location', nameTh: string } | null, province: { __typename?: 'Province', nameTh: string } | null }> } };

export type CountExamEventReportItemSummaryQueryVariables = Exact<{
  countExamEventReportItemSummaryInput: CountExamEventReportItemSummaryInput;
}>;


export type CountExamEventReportItemSummaryQuery = { __typename?: 'Query', reportCountExamEventReportItemSummary: { __typename?: 'CountExamEventReportItemSummaryOutput', summariesCount: any } };

export type ExportExamEventReportItemsQueryVariables = Exact<{
  exportExamEventReportItemsInput: ExportExamEventReportItemsInput;
}>;


export type ExportExamEventReportItemsQuery = { __typename?: 'Query', reportExportExamEventReportItems: { __typename?: 'ExportExamEventReportItemsOutput', signedUrl: string } };

export type GetLatestExamEventOverviewReportCreatedAtQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestExamEventOverviewReportCreatedAtQuery = { __typename?: 'Query', reportGetLatestExamEventOverviewReportCreatedAt: { __typename?: 'GetLatestExamEventOverviewReportCreatedAtOutput', latestCreatedAt: Date } };

export type GetAllProvincesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProvincesQuery = { __typename?: 'Query', reportGetAllProvinces: { __typename?: 'GetAllProvincesOutput', provinces: Array<{ __typename?: 'Province', id: string, nameTh: string }> } };

export type GetLatestExamQSetUsageReportCreatedAtQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestExamQSetUsageReportCreatedAtQuery = { __typename?: 'Query', reportGetLatestExamQSetUsageReportCreatedAt: { __typename?: 'GetLatestExamQSetUsageReportCreatedAtOutput', latestCreatedAt: Date } };

export type GetSearchExamQSetUsageRecordsQueryVariables = Exact<{
  searchExamQSetUsageRecordsInput: SearchExamQSetUsageRecordsInput;
}>;


export type GetSearchExamQSetUsageRecordsQuery = { __typename?: 'Query', reportSearchExamQSetUsageRecords: { __typename?: 'SearchExamQSetUsageRecordsOutput', total: number, records: Array<{ __typename?: 'ExamQSetUsageRecord', examCourseCode: string, qSetCode: string, qConfigRef: number, startedAt: Date, endedAt: Date | null, pAverage: number, examineeCount: number, passedExamineeCount: number, passedRate: number, maxScore: number, minScore: number, averageScore: number, standardDeviationScore: number }> } };

export type ExportExamQSetUsageRecordsQueryVariables = Exact<{
  exportExamQSetUsageRecordsInput: ExportExamQSetUsageRecordsInput;
}>;


export type ExportExamQSetUsageRecordsQuery = { __typename?: 'Query', reportExportExamQSetUsageRecords: { __typename?: 'ExportExamQSetUsageRecordsOutput', signedUrl: string } };

export type SearchQuestionItemAnalysisYearlyRecordsQueryVariables = Exact<{
  searchQuestionItemAnalysisYearlyRecordsInput: SearchQuestionItemAnalysisYearlyRecordsInput;
}>;


export type SearchQuestionItemAnalysisYearlyRecordsQuery = { __typename?: 'Query', reportSearchQuestionItemAnalysisYearlyRecords: { __typename?: 'SearchQuestionItemAnalysisYearlyRecordsOutput', total: number, records: Array<{ __typename?: 'QuestionItemAnalysisYearlyRecord', questionId: string, questionRefCode: string, firstPublishedAt: Date, lastPublishedAt: Date, calculated: boolean, status: QuestionStatus, pInitial: number, pUsed: number, bIndexInitial: number | null, yearlyQuestionItems: Array<{ __typename?: 'YearlyQuestionItem', year: number, totalExaminees: number, pCalculated: number | null, bIndex: number }>, summaryQuestionItem: { __typename?: 'SummaryQuestionItem', totalExaminees: number, pCalculated: number | null, bIndex: number } }> } };

export type ExportQuestionItemAnalysisYearlyRecordsQueryVariables = Exact<{
  exportQuestionItemAnalysisYearlyRecordsInput: ExportQuestionItemAnalysisYearlyRecordsInput;
}>;


export type ExportQuestionItemAnalysisYearlyRecordsQuery = { __typename?: 'Query', reportExportQuestionItemAnalysisYearlyRecords: { __typename?: 'ExportQuestionItemAnalysisYearlyRecordsOutput', signedUrl: string } };

export type GetLatestQuestionItemAnalysisYearlyReportCreatedAtQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestQuestionItemAnalysisYearlyReportCreatedAtQuery = { __typename?: 'Query', reportGetLatestQuestionItemAnalysisYearlyReportCreatedAt: { __typename?: 'GetLatestQuestionItemAnalysisYearlyReportCreatedAtOutput', latestCreatedAt: Date } };

export type SearchQuestionItemAnalysisRecordsQueryVariables = Exact<{
  searchQuestionItemAnalysisRecordsInput: SearchQuestionItemAnalysisRecordsInput;
}>;


export type SearchQuestionItemAnalysisRecordsQuery = { __typename?: 'Query', reportSearchQuestionItemAnalysisRecords: { __typename?: 'SearchQuestionItemAnalysisRecordsOutput', total: number, records: Array<{ __typename?: 'QuestionItemAnalysisRecord', questionId: string, questionRefCode: string, firstPublishedAt: Date, lastPublishedAt: Date, calculated: boolean, status: QuestionStatus, pInitial: number, pUse: number, bIndexInitial: number | null, answer: string, totalNumberOfPassed: number, totalNumberOfFailed: number, totalExaminees: number, bIndex: number, pCalculated: number | null, numbersOfPassed: Array<{ __typename?: 'AnswerCount', answer: string, total: number | null }>, numbersOfFailed: Array<{ __typename?: 'AnswerCount', answer: string, total: number | null }>, numbersOfExaminees: Array<{ __typename?: 'AnswerCount', answer: string, total: number | null }>, percentageOfAnswered: Array<{ __typename?: 'PercentageOfAnswered', answer: string, total: number | null }> }> } };

export type GetAllQBankStructuresQueryVariables = Exact<{
  getAllQBankStructuresInput: GetAllQBankStructuresInput;
}>;


export type GetAllQBankStructuresQuery = { __typename?: 'Query', reportGetAllQBankStructures: { __typename?: 'GetAllQBankStructuresOutput', qBankStructures: Array<{ __typename?: 'QBankStructure', id: string, name: string, code: number }> } };

export type GetPAnalysisCellsQueryVariables = Exact<{
  getPAnalysisCellsInput: GetPAnalysisCellsInput;
}>;


export type GetPAnalysisCellsQuery = { __typename?: 'Query', reportGetPAnalysisCells: { __typename?: 'GetPAnalysisCellsOutput', total: number, cells: Array<{ __typename?: 'PAnalysisCell', pUsedDifficulty: QuestionDifficulty, pCalculatedWithThresholdDifficulty: QuestionDifficulty, totalQuestions: number }> } };

export type AdjustQuestionsPValuesMutationVariables = Exact<{
  adjustQuestionsPValuesInput: AdjustQuestionsPValuesInput;
}>;


export type AdjustQuestionsPValuesMutation = { __typename?: 'Mutation', reportAdjustQuestionsPValues: { __typename?: 'AdjustQuestionsPValuesOutput', status: GenericResponseStatus, message: string } };

export type ExportQuestionItemAnalysisRecordsQueryVariables = Exact<{
  exportQuestionItemAnalysisRecordsInput: ExportQuestionItemAnalysisRecordsInput;
}>;


export type ExportQuestionItemAnalysisRecordsQuery = { __typename?: 'Query', reportExportQuestionItemAnalysisRecords: { __typename?: 'ExportQuestionItemAnalysisRecordsOutput', signedUrl: string } };

export type GetLatestQuestionItemAnalysisReportCreatedAtQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestQuestionItemAnalysisReportCreatedAtQuery = { __typename?: 'Query', reportGetLatestQuestionItemAnalysisReportCreatedAt: { __typename?: 'GetLatestQuestionItemAnalysisReportCreatedAtOutput', latestCreatedAt: Date } };

export type SearchQuestionQSetUsageRecordsQueryVariables = Exact<{
  searchQuestionQSetUsageRecordsInput: SearchQuestionQSetUsageRecordsInput;
}>;


export type SearchQuestionQSetUsageRecordsQuery = { __typename?: 'Query', reportSearchQuestionQSetUsageRecords: { __typename?: 'SearchQuestionQSetUsageRecordsOutput', total: number, records: Array<{ __typename?: 'QuestionQSetUsageRecord', questionId: string, questionRefCode: string, calculated: boolean, pInitial: number, pUsed: number, bIndexInitial: number | null, qSetUsages: Array<{ __typename?: 'QSetUsage', qSetCodeNumber: number, isUsed: boolean }> }> } };

export type ExportQuestionQSetUsageRecordsQueryVariables = Exact<{
  exportQuestionQSetUsageRecordsInput: ExportQuestionQSetUsageRecordsInput;
}>;


export type ExportQuestionQSetUsageRecordsQuery = { __typename?: 'Query', reportExportQuestionQSetUsageRecords: { __typename?: 'ExportQuestionQSetUsageRecordsOutput', signedUrl: string } };

export type GetLatestQuestionQSetUsageReportUpdatedAtQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestQuestionQSetUsageReportUpdatedAtQuery = { __typename?: 'Query', reportGetLatestQuestionQSetUsageReportUpdatedAt: { __typename?: 'GetLatestQuestionQSetUsageReportUpdatedAtOutput', latestUpdatedAt: Date } };

export type GetShortQuestionnaireSummaryReportQueryVariables = Exact<{
  input: GetShortQuestionnaireSummaryReportInput;
}>;


export type GetShortQuestionnaireSummaryReportQuery = { __typename?: 'Query', reportGetShortQuestionnaireSummaryReport: { __typename?: 'ShortQuestionnaireSummaryReportOutput', age: { __typename?: 'ShortQuestionnaireReportSection', rows: Array<{ __typename?: 'ShortQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'ShortQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, highestEducationLevel: { __typename?: 'ShortQuestionnaireReportSection', rows: Array<{ __typename?: 'ShortQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'ShortQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, currentOrganization: { __typename?: 'ShortQuestionnaireReportSection', rows: Array<{ __typename?: 'ShortQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'ShortQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, examAttendingObjectives: { __typename?: 'ShortQuestionnaireReportSection', rows: Array<{ __typename?: 'ShortQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'ShortQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, locationSatisfaction: { __typename?: 'ShortQuestionnaireReportSection', rows: Array<{ __typename?: 'ShortQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'ShortQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, staffServicesSatisfaction: { __typename?: 'ShortQuestionnaireReportSection', rows: Array<{ __typename?: 'ShortQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'ShortQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, systemUsabilitySatisfaction: { __typename?: 'ShortQuestionnaireReportSection', rows: Array<{ __typename?: 'ShortQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'ShortQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, systemStabilitySatisfaction: { __typename?: 'ShortQuestionnaireReportSection', rows: Array<{ __typename?: 'ShortQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'ShortQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } } } };

export type ShortQuestionnaireSectionFragment = { __typename?: 'ShortQuestionnaireReportSection', rows: Array<{ __typename?: 'ShortQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'ShortQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } };

export type ShortQuestionnaireRowFragment = { __typename?: 'ShortQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } };

export type ShortQuestionnaireMetricsFragment = { __typename?: 'ShortQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number };

export type GetStandardQuestionnaireSummaryReportQueryVariables = Exact<{
  input: GetStandardQuestionnaireSummaryReportInput;
}>;


export type GetStandardQuestionnaireSummaryReportQuery = { __typename?: 'Query', reportGetStandardQuestionnaireSummaryReport: { __typename?: 'StandardQuestionnaireSummaryReportOutput', age: { __typename?: 'StandardQuestionnaireReportSection', rows: Array<{ __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, highestEducationLevel: { __typename?: 'StandardQuestionnaireReportSection', rows: Array<{ __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, currentOrganization: { __typename?: 'StandardQuestionnaireReportSection', rows: Array<{ __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, examAttendingObjectives: { __typename?: 'StandardQuestionnaireReportSection', rows: Array<{ __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, locationSatisfaction: { __typename?: 'StandardQuestionnaireReportSection', rows: Array<{ __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, staffServicesSatisfaction: { __typename?: 'StandardQuestionnaireReportSection', rows: Array<{ __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, systemUsabilitySatisfaction: { __typename?: 'StandardQuestionnaireReportSection', rows: Array<{ __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, systemStabilitySatisfaction: { __typename?: 'StandardQuestionnaireReportSection', rows: Array<{ __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, major: { __typename?: 'StandardQuestionnaireReportSection', rows: Array<{ __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, examAttempted: { __typename?: 'StandardQuestionnaireReportSection', rows: Array<{ __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, workExperience: { __typename?: 'StandardQuestionnaireReportSection', rows: Array<{ __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, examPreparations: { __typename?: 'StandardQuestionnaireReportSection', rows: Array<{ __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } } } };

export type StandardQuestionnaireSectionFragment = { __typename?: 'StandardQuestionnaireReportSection', rows: Array<{ __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } };

export type StandardQuestionnaireRowFragment = { __typename?: 'StandardQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } };

export type StandardQuestionnaireMetricsFragment = { __typename?: 'StandardQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number };

export type GetLongQuestionnaireSummaryReportQueryVariables = Exact<{
  input: GetLongQuestionnaireSummaryReportInput;
}>;


export type GetLongQuestionnaireSummaryReportQuery = { __typename?: 'Query', reportGetLongQuestionnaireSummaryReport: { __typename?: 'LongQuestionnaireSummaryReportOutput', age: { __typename?: 'LongQuestionnaireReportSection', rows: Array<{ __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, highestEducationLevel: { __typename?: 'LongQuestionnaireReportSection', rows: Array<{ __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, major: { __typename?: 'LongQuestionnaireReportSection', rows: Array<{ __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, examProvince: { __typename?: 'LongQuestionnaireReportSection', rows: Array<{ __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, currentOccupation: { __typename?: 'LongQuestionnaireReportSection', rows: Array<{ __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, currentOrganization: { __typename?: 'LongQuestionnaireReportSection', rows: Array<{ __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, workExperience: { __typename?: 'LongQuestionnaireReportSection', rows: Array<{ __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, examAttempted: { __typename?: 'LongQuestionnaireReportSection', rows: Array<{ __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, examPreparations: { __typename?: 'LongQuestionnaireReportSection', rows: Array<{ __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, examAttendingObjectives: { __typename?: 'LongQuestionnaireReportSection', rows: Array<{ __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, examDevice: { __typename?: 'LongQuestionnaireReportSection', rows: Array<{ __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, referralSource: { __typename?: 'LongQuestionnaireReportSection', rows: Array<{ __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, examReadiness: { __typename?: 'LongQuestionnaireReportSection', rows: Array<{ __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, locationSatisfaction: { __typename?: 'LongQuestionnaireReportSection', rows: Array<{ __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, staffServicesSatisfaction: { __typename?: 'LongQuestionnaireReportSection', rows: Array<{ __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, systemUsabilitySatisfaction: { __typename?: 'LongQuestionnaireReportSection', rows: Array<{ __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } }, systemStabilitySatisfaction: { __typename?: 'LongQuestionnaireReportSection', rows: Array<{ __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } } } };

export type LongQuestionnaireSectionFragment = { __typename?: 'LongQuestionnaireReportSection', rows: Array<{ __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } }>, total: { __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } } };

export type LongQuestionnaireRowFragment = { __typename?: 'LongQuestionnaireReportRow', optionKey: string, publicPlusInHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, public: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number }, inHouse: { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number } };

export type LongQuestionnaireMetricsFragment = { __typename?: 'LongQuestionnaireReportMetrics', count: number, pass: number, fail: number, passingRate: number, avgScore: number };

export type ExportQuestionnaireSummaryReportMutationVariables = Exact<{
  input: ExportQuestionnaireSummaryReportInput;
}>;


export type ExportQuestionnaireSummaryReportMutation = { __typename?: 'Mutation', reportExportQuestionnaireSummaryReport: { __typename?: 'ExportQuestionnaireSummaryReportOutput', signedUrl: string } };

export const ShortQuestionnaireMetricsFragmentDoc = gql`
    fragment shortQuestionnaireMetrics on ShortQuestionnaireReportMetrics {
  count
  pass
  fail
  passingRate
  avgScore
}
    `;
export const ShortQuestionnaireRowFragmentDoc = gql`
    fragment shortQuestionnaireRow on ShortQuestionnaireReportRow {
  optionKey
  publicPlusInHouse {
    ...shortQuestionnaireMetrics
  }
  public {
    ...shortQuestionnaireMetrics
  }
  inHouse {
    ...shortQuestionnaireMetrics
  }
}
    ${ShortQuestionnaireMetricsFragmentDoc}`;
export const ShortQuestionnaireSectionFragmentDoc = gql`
    fragment shortQuestionnaireSection on ShortQuestionnaireReportSection {
  rows {
    ...shortQuestionnaireRow
  }
  total {
    ...shortQuestionnaireRow
  }
}
    ${ShortQuestionnaireRowFragmentDoc}`;
export const StandardQuestionnaireMetricsFragmentDoc = gql`
    fragment standardQuestionnaireMetrics on StandardQuestionnaireReportMetrics {
  count
  pass
  fail
  passingRate
  avgScore
}
    `;
export const StandardQuestionnaireRowFragmentDoc = gql`
    fragment standardQuestionnaireRow on StandardQuestionnaireReportRow {
  optionKey
  publicPlusInHouse {
    ...standardQuestionnaireMetrics
  }
  public {
    ...standardQuestionnaireMetrics
  }
  inHouse {
    ...standardQuestionnaireMetrics
  }
}
    ${StandardQuestionnaireMetricsFragmentDoc}`;
export const StandardQuestionnaireSectionFragmentDoc = gql`
    fragment standardQuestionnaireSection on StandardQuestionnaireReportSection {
  rows {
    ...standardQuestionnaireRow
  }
  total {
    ...standardQuestionnaireRow
  }
}
    ${StandardQuestionnaireRowFragmentDoc}`;
export const LongQuestionnaireMetricsFragmentDoc = gql`
    fragment longQuestionnaireMetrics on LongQuestionnaireReportMetrics {
  count
  pass
  fail
  passingRate
  avgScore
}
    `;
export const LongQuestionnaireRowFragmentDoc = gql`
    fragment longQuestionnaireRow on LongQuestionnaireReportRow {
  optionKey
  publicPlusInHouse {
    ...longQuestionnaireMetrics
  }
  public {
    ...longQuestionnaireMetrics
  }
  inHouse {
    ...longQuestionnaireMetrics
  }
}
    ${LongQuestionnaireMetricsFragmentDoc}`;
export const LongQuestionnaireSectionFragmentDoc = gql`
    fragment longQuestionnaireSection on LongQuestionnaireReportSection {
  rows {
    ...longQuestionnaireRow
  }
  total {
    ...longQuestionnaireRow
  }
}
    ${LongQuestionnaireRowFragmentDoc}`;
export const GetMyExamCentersDocument = gql`
    query getMyExamCenters {
  reportGetMyExamCenters {
    examCenters {
      code
      examCenterId
    }
  }
}
    `;

/**
 * __useGetMyExamCentersQuery__
 *
 * To run a query within a React component, call `useGetMyExamCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyExamCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyExamCentersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyExamCentersQuery(baseOptions?: Apollo.QueryHookOptions<GetMyExamCentersQuery, GetMyExamCentersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyExamCentersQuery, GetMyExamCentersQueryVariables>(GetMyExamCentersDocument, options);
      }
export function useGetMyExamCentersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyExamCentersQuery, GetMyExamCentersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyExamCentersQuery, GetMyExamCentersQueryVariables>(GetMyExamCentersDocument, options);
        }
// @ts-ignore
export function useGetMyExamCentersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyExamCentersQuery, GetMyExamCentersQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyExamCentersQuery, GetMyExamCentersQueryVariables>;
export function useGetMyExamCentersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyExamCentersQuery, GetMyExamCentersQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyExamCentersQuery | undefined, GetMyExamCentersQueryVariables>;
export function useGetMyExamCentersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyExamCentersQuery, GetMyExamCentersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyExamCentersQuery, GetMyExamCentersQueryVariables>(GetMyExamCentersDocument, options);
        }
export type GetMyExamCentersQueryHookResult = ReturnType<typeof useGetMyExamCentersQuery>;
export type GetMyExamCentersLazyQueryHookResult = ReturnType<typeof useGetMyExamCentersLazyQuery>;
export type GetMyExamCentersSuspenseQueryHookResult = ReturnType<typeof useGetMyExamCentersSuspenseQuery>;
export type GetMyExamCentersQueryResult = Apollo.QueryResult<GetMyExamCentersQuery, GetMyExamCentersQueryVariables>;
export const GetAllExamCentersDocument = gql`
    query getAllExamCenters {
  reportGetAllExamCenters {
    examCenters {
      id
      nameTh
      code
    }
  }
}
    `;

/**
 * __useGetAllExamCentersQuery__
 *
 * To run a query within a React component, call `useGetAllExamCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllExamCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllExamCentersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllExamCentersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllExamCentersQuery, GetAllExamCentersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllExamCentersQuery, GetAllExamCentersQueryVariables>(GetAllExamCentersDocument, options);
      }
export function useGetAllExamCentersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllExamCentersQuery, GetAllExamCentersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllExamCentersQuery, GetAllExamCentersQueryVariables>(GetAllExamCentersDocument, options);
        }
// @ts-ignore
export function useGetAllExamCentersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllExamCentersQuery, GetAllExamCentersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllExamCentersQuery, GetAllExamCentersQueryVariables>;
export function useGetAllExamCentersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllExamCentersQuery, GetAllExamCentersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllExamCentersQuery | undefined, GetAllExamCentersQueryVariables>;
export function useGetAllExamCentersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllExamCentersQuery, GetAllExamCentersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllExamCentersQuery, GetAllExamCentersQueryVariables>(GetAllExamCentersDocument, options);
        }
export type GetAllExamCentersQueryHookResult = ReturnType<typeof useGetAllExamCentersQuery>;
export type GetAllExamCentersLazyQueryHookResult = ReturnType<typeof useGetAllExamCentersLazyQuery>;
export type GetAllExamCentersSuspenseQueryHookResult = ReturnType<typeof useGetAllExamCentersSuspenseQuery>;
export type GetAllExamCentersQueryResult = Apollo.QueryResult<GetAllExamCentersQuery, GetAllExamCentersQueryVariables>;
export const GetExamCourseAnalysisReportDocument = gql`
    query getExamCourseAnalysisReport($getExamCourseAnalysisReportInput: GetExamCourseAnalysisReportInput!) {
  reportGetExamCourseAnalysisReport(
    getExamCourseAnalysisReportInput: $getExamCourseAnalysisReportInput
  ) {
    examCourseAnalysisReports {
      id
      examId
      examCourseCode
      examCourseType
      qConfigRef
      fullScore
      standardDeviationScore
      maxScore
      minScore
      averageScore
      applicantExamineeCount {
        inHouse
        public
        total
      }
      attendedExamineeCount {
        inHouse
        public
        total
      }
      uniqueExamineeCount
      passedExamineeCount {
        inHouse
        public
        total
      }
      failedExamineeCount {
        inHouse
        public
        total
      }
      passedRate {
        inHouse
        public
        total
      }
      avgAttempts
      examCourse {
        id
        code
        name
        examId
      }
    }
  }
}
    `;

/**
 * __useGetExamCourseAnalysisReportQuery__
 *
 * To run a query within a React component, call `useGetExamCourseAnalysisReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExamCourseAnalysisReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExamCourseAnalysisReportQuery({
 *   variables: {
 *      getExamCourseAnalysisReportInput: // value for 'getExamCourseAnalysisReportInput'
 *   },
 * });
 */
export function useGetExamCourseAnalysisReportQuery(baseOptions: Apollo.QueryHookOptions<GetExamCourseAnalysisReportQuery, GetExamCourseAnalysisReportQueryVariables> & ({ variables: GetExamCourseAnalysisReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExamCourseAnalysisReportQuery, GetExamCourseAnalysisReportQueryVariables>(GetExamCourseAnalysisReportDocument, options);
      }
export function useGetExamCourseAnalysisReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExamCourseAnalysisReportQuery, GetExamCourseAnalysisReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExamCourseAnalysisReportQuery, GetExamCourseAnalysisReportQueryVariables>(GetExamCourseAnalysisReportDocument, options);
        }
// @ts-ignore
export function useGetExamCourseAnalysisReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExamCourseAnalysisReportQuery, GetExamCourseAnalysisReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetExamCourseAnalysisReportQuery, GetExamCourseAnalysisReportQueryVariables>;
export function useGetExamCourseAnalysisReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCourseAnalysisReportQuery, GetExamCourseAnalysisReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetExamCourseAnalysisReportQuery | undefined, GetExamCourseAnalysisReportQueryVariables>;
export function useGetExamCourseAnalysisReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExamCourseAnalysisReportQuery, GetExamCourseAnalysisReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExamCourseAnalysisReportQuery, GetExamCourseAnalysisReportQueryVariables>(GetExamCourseAnalysisReportDocument, options);
        }
export type GetExamCourseAnalysisReportQueryHookResult = ReturnType<typeof useGetExamCourseAnalysisReportQuery>;
export type GetExamCourseAnalysisReportLazyQueryHookResult = ReturnType<typeof useGetExamCourseAnalysisReportLazyQuery>;
export type GetExamCourseAnalysisReportSuspenseQueryHookResult = ReturnType<typeof useGetExamCourseAnalysisReportSuspenseQuery>;
export type GetExamCourseAnalysisReportQueryResult = Apollo.QueryResult<GetExamCourseAnalysisReportQuery, GetExamCourseAnalysisReportQueryVariables>;
export const GetLatestExamCourseAnalysisReportCreatedAtDocument = gql`
    query getLatestExamCourseAnalysisReportCreatedAt {
  reportGetLatestExamCourseAnalysisReportCreatedAt {
    latestCreatedAt
  }
}
    `;

/**
 * __useGetLatestExamCourseAnalysisReportCreatedAtQuery__
 *
 * To run a query within a React component, call `useGetLatestExamCourseAnalysisReportCreatedAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestExamCourseAnalysisReportCreatedAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestExamCourseAnalysisReportCreatedAtQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLatestExamCourseAnalysisReportCreatedAtQuery(baseOptions?: Apollo.QueryHookOptions<GetLatestExamCourseAnalysisReportCreatedAtQuery, GetLatestExamCourseAnalysisReportCreatedAtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestExamCourseAnalysisReportCreatedAtQuery, GetLatestExamCourseAnalysisReportCreatedAtQueryVariables>(GetLatestExamCourseAnalysisReportCreatedAtDocument, options);
      }
export function useGetLatestExamCourseAnalysisReportCreatedAtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestExamCourseAnalysisReportCreatedAtQuery, GetLatestExamCourseAnalysisReportCreatedAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestExamCourseAnalysisReportCreatedAtQuery, GetLatestExamCourseAnalysisReportCreatedAtQueryVariables>(GetLatestExamCourseAnalysisReportCreatedAtDocument, options);
        }
// @ts-ignore
export function useGetLatestExamCourseAnalysisReportCreatedAtSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLatestExamCourseAnalysisReportCreatedAtQuery, GetLatestExamCourseAnalysisReportCreatedAtQueryVariables>): Apollo.UseSuspenseQueryResult<GetLatestExamCourseAnalysisReportCreatedAtQuery, GetLatestExamCourseAnalysisReportCreatedAtQueryVariables>;
export function useGetLatestExamCourseAnalysisReportCreatedAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestExamCourseAnalysisReportCreatedAtQuery, GetLatestExamCourseAnalysisReportCreatedAtQueryVariables>): Apollo.UseSuspenseQueryResult<GetLatestExamCourseAnalysisReportCreatedAtQuery | undefined, GetLatestExamCourseAnalysisReportCreatedAtQueryVariables>;
export function useGetLatestExamCourseAnalysisReportCreatedAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestExamCourseAnalysisReportCreatedAtQuery, GetLatestExamCourseAnalysisReportCreatedAtQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestExamCourseAnalysisReportCreatedAtQuery, GetLatestExamCourseAnalysisReportCreatedAtQueryVariables>(GetLatestExamCourseAnalysisReportCreatedAtDocument, options);
        }
export type GetLatestExamCourseAnalysisReportCreatedAtQueryHookResult = ReturnType<typeof useGetLatestExamCourseAnalysisReportCreatedAtQuery>;
export type GetLatestExamCourseAnalysisReportCreatedAtLazyQueryHookResult = ReturnType<typeof useGetLatestExamCourseAnalysisReportCreatedAtLazyQuery>;
export type GetLatestExamCourseAnalysisReportCreatedAtSuspenseQueryHookResult = ReturnType<typeof useGetLatestExamCourseAnalysisReportCreatedAtSuspenseQuery>;
export type GetLatestExamCourseAnalysisReportCreatedAtQueryResult = Apollo.QueryResult<GetLatestExamCourseAnalysisReportCreatedAtQuery, GetLatestExamCourseAnalysisReportCreatedAtQueryVariables>;
export const ExportReportExportExamCourseAnalysisReportDocument = gql`
    query exportReportExportExamCourseAnalysisReport($exportExamCourseAnalysisReportInput: ExportExamCourseAnalysisReportInput!) {
  reportExportExamCourseAnalysisReport(
    exportExamCourseAnalysisReportInput: $exportExamCourseAnalysisReportInput
  ) {
    signedUrl
  }
}
    `;

/**
 * __useExportReportExportExamCourseAnalysisReportQuery__
 *
 * To run a query within a React component, call `useExportReportExportExamCourseAnalysisReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportReportExportExamCourseAnalysisReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportReportExportExamCourseAnalysisReportQuery({
 *   variables: {
 *      exportExamCourseAnalysisReportInput: // value for 'exportExamCourseAnalysisReportInput'
 *   },
 * });
 */
export function useExportReportExportExamCourseAnalysisReportQuery(baseOptions: Apollo.QueryHookOptions<ExportReportExportExamCourseAnalysisReportQuery, ExportReportExportExamCourseAnalysisReportQueryVariables> & ({ variables: ExportReportExportExamCourseAnalysisReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportReportExportExamCourseAnalysisReportQuery, ExportReportExportExamCourseAnalysisReportQueryVariables>(ExportReportExportExamCourseAnalysisReportDocument, options);
      }
export function useExportReportExportExamCourseAnalysisReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportReportExportExamCourseAnalysisReportQuery, ExportReportExportExamCourseAnalysisReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportReportExportExamCourseAnalysisReportQuery, ExportReportExportExamCourseAnalysisReportQueryVariables>(ExportReportExportExamCourseAnalysisReportDocument, options);
        }
// @ts-ignore
export function useExportReportExportExamCourseAnalysisReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportReportExportExamCourseAnalysisReportQuery, ExportReportExportExamCourseAnalysisReportQueryVariables>): Apollo.UseSuspenseQueryResult<ExportReportExportExamCourseAnalysisReportQuery, ExportReportExportExamCourseAnalysisReportQueryVariables>;
export function useExportReportExportExamCourseAnalysisReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportReportExportExamCourseAnalysisReportQuery, ExportReportExportExamCourseAnalysisReportQueryVariables>): Apollo.UseSuspenseQueryResult<ExportReportExportExamCourseAnalysisReportQuery | undefined, ExportReportExportExamCourseAnalysisReportQueryVariables>;
export function useExportReportExportExamCourseAnalysisReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportReportExportExamCourseAnalysisReportQuery, ExportReportExportExamCourseAnalysisReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportReportExportExamCourseAnalysisReportQuery, ExportReportExportExamCourseAnalysisReportQueryVariables>(ExportReportExportExamCourseAnalysisReportDocument, options);
        }
export type ExportReportExportExamCourseAnalysisReportQueryHookResult = ReturnType<typeof useExportReportExportExamCourseAnalysisReportQuery>;
export type ExportReportExportExamCourseAnalysisReportLazyQueryHookResult = ReturnType<typeof useExportReportExportExamCourseAnalysisReportLazyQuery>;
export type ExportReportExportExamCourseAnalysisReportSuspenseQueryHookResult = ReturnType<typeof useExportReportExportExamCourseAnalysisReportSuspenseQuery>;
export type ExportReportExportExamCourseAnalysisReportQueryResult = Apollo.QueryResult<ExportReportExportExamCourseAnalysisReportQuery, ExportReportExportExamCourseAnalysisReportQueryVariables>;
export const GetAllExamCoursesDocument = gql`
    query getAllExamCourses {
  reportGetAllExamCourses {
    examCourses {
      code
      id
    }
  }
}
    `;

/**
 * __useGetAllExamCoursesQuery__
 *
 * To run a query within a React component, call `useGetAllExamCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllExamCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllExamCoursesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllExamCoursesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllExamCoursesQuery, GetAllExamCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllExamCoursesQuery, GetAllExamCoursesQueryVariables>(GetAllExamCoursesDocument, options);
      }
export function useGetAllExamCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllExamCoursesQuery, GetAllExamCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllExamCoursesQuery, GetAllExamCoursesQueryVariables>(GetAllExamCoursesDocument, options);
        }
// @ts-ignore
export function useGetAllExamCoursesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllExamCoursesQuery, GetAllExamCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllExamCoursesQuery, GetAllExamCoursesQueryVariables>;
export function useGetAllExamCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllExamCoursesQuery, GetAllExamCoursesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllExamCoursesQuery | undefined, GetAllExamCoursesQueryVariables>;
export function useGetAllExamCoursesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllExamCoursesQuery, GetAllExamCoursesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllExamCoursesQuery, GetAllExamCoursesQueryVariables>(GetAllExamCoursesDocument, options);
        }
export type GetAllExamCoursesQueryHookResult = ReturnType<typeof useGetAllExamCoursesQuery>;
export type GetAllExamCoursesLazyQueryHookResult = ReturnType<typeof useGetAllExamCoursesLazyQuery>;
export type GetAllExamCoursesSuspenseQueryHookResult = ReturnType<typeof useGetAllExamCoursesSuspenseQuery>;
export type GetAllExamCoursesQueryResult = Apollo.QueryResult<GetAllExamCoursesQuery, GetAllExamCoursesQueryVariables>;
export const GetQConfigRefCodesByExamCourseDocument = gql`
    query getQConfigRefCodesByExamCourse($getQConfigRefCodesByExamCourseInput: GetQConfigRefCodesByExamCourseInput!) {
  reportGetQConfigRefCodesByExamCourse(
    getQConfigRefCodesByExamCourseInput: $getQConfigRefCodesByExamCourseInput
  ) {
    qConfigRefCodes
  }
}
    `;

/**
 * __useGetQConfigRefCodesByExamCourseQuery__
 *
 * To run a query within a React component, call `useGetQConfigRefCodesByExamCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQConfigRefCodesByExamCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQConfigRefCodesByExamCourseQuery({
 *   variables: {
 *      getQConfigRefCodesByExamCourseInput: // value for 'getQConfigRefCodesByExamCourseInput'
 *   },
 * });
 */
export function useGetQConfigRefCodesByExamCourseQuery(baseOptions: Apollo.QueryHookOptions<GetQConfigRefCodesByExamCourseQuery, GetQConfigRefCodesByExamCourseQueryVariables> & ({ variables: GetQConfigRefCodesByExamCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQConfigRefCodesByExamCourseQuery, GetQConfigRefCodesByExamCourseQueryVariables>(GetQConfigRefCodesByExamCourseDocument, options);
      }
export function useGetQConfigRefCodesByExamCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQConfigRefCodesByExamCourseQuery, GetQConfigRefCodesByExamCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQConfigRefCodesByExamCourseQuery, GetQConfigRefCodesByExamCourseQueryVariables>(GetQConfigRefCodesByExamCourseDocument, options);
        }
// @ts-ignore
export function useGetQConfigRefCodesByExamCourseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQConfigRefCodesByExamCourseQuery, GetQConfigRefCodesByExamCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetQConfigRefCodesByExamCourseQuery, GetQConfigRefCodesByExamCourseQueryVariables>;
export function useGetQConfigRefCodesByExamCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQConfigRefCodesByExamCourseQuery, GetQConfigRefCodesByExamCourseQueryVariables>): Apollo.UseSuspenseQueryResult<GetQConfigRefCodesByExamCourseQuery | undefined, GetQConfigRefCodesByExamCourseQueryVariables>;
export function useGetQConfigRefCodesByExamCourseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQConfigRefCodesByExamCourseQuery, GetQConfigRefCodesByExamCourseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQConfigRefCodesByExamCourseQuery, GetQConfigRefCodesByExamCourseQueryVariables>(GetQConfigRefCodesByExamCourseDocument, options);
        }
export type GetQConfigRefCodesByExamCourseQueryHookResult = ReturnType<typeof useGetQConfigRefCodesByExamCourseQuery>;
export type GetQConfigRefCodesByExamCourseLazyQueryHookResult = ReturnType<typeof useGetQConfigRefCodesByExamCourseLazyQuery>;
export type GetQConfigRefCodesByExamCourseSuspenseQueryHookResult = ReturnType<typeof useGetQConfigRefCodesByExamCourseSuspenseQuery>;
export type GetQConfigRefCodesByExamCourseQueryResult = Apollo.QueryResult<GetQConfigRefCodesByExamCourseQuery, GetQConfigRefCodesByExamCourseQueryVariables>;
export const SearchExamEventReportItemsDocument = gql`
    query searchExamEventReportItems($searchExamEventReportItemsInput: SearchExamEventReportItemsInput!) {
  reportSearchExamEventReportItems(
    searchExamEventReportItemsInput: $searchExamEventReportItemsInput
  ) {
    examEventReportItems {
      id
      startedAt
      endedAt
      examCenterCode
      registrationType
      examType
      seatCount
      examineeCount
      attendedExamineeCount
      location {
        nameTh
      }
      province {
        nameTh
      }
    }
    total
  }
}
    `;

/**
 * __useSearchExamEventReportItemsQuery__
 *
 * To run a query within a React component, call `useSearchExamEventReportItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExamEventReportItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExamEventReportItemsQuery({
 *   variables: {
 *      searchExamEventReportItemsInput: // value for 'searchExamEventReportItemsInput'
 *   },
 * });
 */
export function useSearchExamEventReportItemsQuery(baseOptions: Apollo.QueryHookOptions<SearchExamEventReportItemsQuery, SearchExamEventReportItemsQueryVariables> & ({ variables: SearchExamEventReportItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExamEventReportItemsQuery, SearchExamEventReportItemsQueryVariables>(SearchExamEventReportItemsDocument, options);
      }
export function useSearchExamEventReportItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExamEventReportItemsQuery, SearchExamEventReportItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExamEventReportItemsQuery, SearchExamEventReportItemsQueryVariables>(SearchExamEventReportItemsDocument, options);
        }
// @ts-ignore
export function useSearchExamEventReportItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchExamEventReportItemsQuery, SearchExamEventReportItemsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchExamEventReportItemsQuery, SearchExamEventReportItemsQueryVariables>;
export function useSearchExamEventReportItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamEventReportItemsQuery, SearchExamEventReportItemsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchExamEventReportItemsQuery | undefined, SearchExamEventReportItemsQueryVariables>;
export function useSearchExamEventReportItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExamEventReportItemsQuery, SearchExamEventReportItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExamEventReportItemsQuery, SearchExamEventReportItemsQueryVariables>(SearchExamEventReportItemsDocument, options);
        }
export type SearchExamEventReportItemsQueryHookResult = ReturnType<typeof useSearchExamEventReportItemsQuery>;
export type SearchExamEventReportItemsLazyQueryHookResult = ReturnType<typeof useSearchExamEventReportItemsLazyQuery>;
export type SearchExamEventReportItemsSuspenseQueryHookResult = ReturnType<typeof useSearchExamEventReportItemsSuspenseQuery>;
export type SearchExamEventReportItemsQueryResult = Apollo.QueryResult<SearchExamEventReportItemsQuery, SearchExamEventReportItemsQueryVariables>;
export const CountExamEventReportItemSummaryDocument = gql`
    query countExamEventReportItemSummary($countExamEventReportItemSummaryInput: CountExamEventReportItemSummaryInput!) {
  reportCountExamEventReportItemSummary(
    countExamEventReportItemSummaryInput: $countExamEventReportItemSummaryInput
  ) {
    summariesCount
  }
}
    `;

/**
 * __useCountExamEventReportItemSummaryQuery__
 *
 * To run a query within a React component, call `useCountExamEventReportItemSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountExamEventReportItemSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountExamEventReportItemSummaryQuery({
 *   variables: {
 *      countExamEventReportItemSummaryInput: // value for 'countExamEventReportItemSummaryInput'
 *   },
 * });
 */
export function useCountExamEventReportItemSummaryQuery(baseOptions: Apollo.QueryHookOptions<CountExamEventReportItemSummaryQuery, CountExamEventReportItemSummaryQueryVariables> & ({ variables: CountExamEventReportItemSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountExamEventReportItemSummaryQuery, CountExamEventReportItemSummaryQueryVariables>(CountExamEventReportItemSummaryDocument, options);
      }
export function useCountExamEventReportItemSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountExamEventReportItemSummaryQuery, CountExamEventReportItemSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountExamEventReportItemSummaryQuery, CountExamEventReportItemSummaryQueryVariables>(CountExamEventReportItemSummaryDocument, options);
        }
// @ts-ignore
export function useCountExamEventReportItemSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountExamEventReportItemSummaryQuery, CountExamEventReportItemSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<CountExamEventReportItemSummaryQuery, CountExamEventReportItemSummaryQueryVariables>;
export function useCountExamEventReportItemSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountExamEventReportItemSummaryQuery, CountExamEventReportItemSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<CountExamEventReportItemSummaryQuery | undefined, CountExamEventReportItemSummaryQueryVariables>;
export function useCountExamEventReportItemSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountExamEventReportItemSummaryQuery, CountExamEventReportItemSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountExamEventReportItemSummaryQuery, CountExamEventReportItemSummaryQueryVariables>(CountExamEventReportItemSummaryDocument, options);
        }
export type CountExamEventReportItemSummaryQueryHookResult = ReturnType<typeof useCountExamEventReportItemSummaryQuery>;
export type CountExamEventReportItemSummaryLazyQueryHookResult = ReturnType<typeof useCountExamEventReportItemSummaryLazyQuery>;
export type CountExamEventReportItemSummarySuspenseQueryHookResult = ReturnType<typeof useCountExamEventReportItemSummarySuspenseQuery>;
export type CountExamEventReportItemSummaryQueryResult = Apollo.QueryResult<CountExamEventReportItemSummaryQuery, CountExamEventReportItemSummaryQueryVariables>;
export const ExportExamEventReportItemsDocument = gql`
    query exportExamEventReportItems($exportExamEventReportItemsInput: ExportExamEventReportItemsInput!) {
  reportExportExamEventReportItems(
    exportExamEventReportItemsInput: $exportExamEventReportItemsInput
  ) {
    signedUrl
  }
}
    `;

/**
 * __useExportExamEventReportItemsQuery__
 *
 * To run a query within a React component, call `useExportExamEventReportItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportExamEventReportItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportExamEventReportItemsQuery({
 *   variables: {
 *      exportExamEventReportItemsInput: // value for 'exportExamEventReportItemsInput'
 *   },
 * });
 */
export function useExportExamEventReportItemsQuery(baseOptions: Apollo.QueryHookOptions<ExportExamEventReportItemsQuery, ExportExamEventReportItemsQueryVariables> & ({ variables: ExportExamEventReportItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportExamEventReportItemsQuery, ExportExamEventReportItemsQueryVariables>(ExportExamEventReportItemsDocument, options);
      }
export function useExportExamEventReportItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportExamEventReportItemsQuery, ExportExamEventReportItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportExamEventReportItemsQuery, ExportExamEventReportItemsQueryVariables>(ExportExamEventReportItemsDocument, options);
        }
// @ts-ignore
export function useExportExamEventReportItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportExamEventReportItemsQuery, ExportExamEventReportItemsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportExamEventReportItemsQuery, ExportExamEventReportItemsQueryVariables>;
export function useExportExamEventReportItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportExamEventReportItemsQuery, ExportExamEventReportItemsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportExamEventReportItemsQuery | undefined, ExportExamEventReportItemsQueryVariables>;
export function useExportExamEventReportItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportExamEventReportItemsQuery, ExportExamEventReportItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportExamEventReportItemsQuery, ExportExamEventReportItemsQueryVariables>(ExportExamEventReportItemsDocument, options);
        }
export type ExportExamEventReportItemsQueryHookResult = ReturnType<typeof useExportExamEventReportItemsQuery>;
export type ExportExamEventReportItemsLazyQueryHookResult = ReturnType<typeof useExportExamEventReportItemsLazyQuery>;
export type ExportExamEventReportItemsSuspenseQueryHookResult = ReturnType<typeof useExportExamEventReportItemsSuspenseQuery>;
export type ExportExamEventReportItemsQueryResult = Apollo.QueryResult<ExportExamEventReportItemsQuery, ExportExamEventReportItemsQueryVariables>;
export const GetLatestExamEventOverviewReportCreatedAtDocument = gql`
    query getLatestExamEventOverviewReportCreatedAt {
  reportGetLatestExamEventOverviewReportCreatedAt {
    latestCreatedAt
  }
}
    `;

/**
 * __useGetLatestExamEventOverviewReportCreatedAtQuery__
 *
 * To run a query within a React component, call `useGetLatestExamEventOverviewReportCreatedAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestExamEventOverviewReportCreatedAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestExamEventOverviewReportCreatedAtQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLatestExamEventOverviewReportCreatedAtQuery(baseOptions?: Apollo.QueryHookOptions<GetLatestExamEventOverviewReportCreatedAtQuery, GetLatestExamEventOverviewReportCreatedAtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestExamEventOverviewReportCreatedAtQuery, GetLatestExamEventOverviewReportCreatedAtQueryVariables>(GetLatestExamEventOverviewReportCreatedAtDocument, options);
      }
export function useGetLatestExamEventOverviewReportCreatedAtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestExamEventOverviewReportCreatedAtQuery, GetLatestExamEventOverviewReportCreatedAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestExamEventOverviewReportCreatedAtQuery, GetLatestExamEventOverviewReportCreatedAtQueryVariables>(GetLatestExamEventOverviewReportCreatedAtDocument, options);
        }
// @ts-ignore
export function useGetLatestExamEventOverviewReportCreatedAtSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLatestExamEventOverviewReportCreatedAtQuery, GetLatestExamEventOverviewReportCreatedAtQueryVariables>): Apollo.UseSuspenseQueryResult<GetLatestExamEventOverviewReportCreatedAtQuery, GetLatestExamEventOverviewReportCreatedAtQueryVariables>;
export function useGetLatestExamEventOverviewReportCreatedAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestExamEventOverviewReportCreatedAtQuery, GetLatestExamEventOverviewReportCreatedAtQueryVariables>): Apollo.UseSuspenseQueryResult<GetLatestExamEventOverviewReportCreatedAtQuery | undefined, GetLatestExamEventOverviewReportCreatedAtQueryVariables>;
export function useGetLatestExamEventOverviewReportCreatedAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestExamEventOverviewReportCreatedAtQuery, GetLatestExamEventOverviewReportCreatedAtQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestExamEventOverviewReportCreatedAtQuery, GetLatestExamEventOverviewReportCreatedAtQueryVariables>(GetLatestExamEventOverviewReportCreatedAtDocument, options);
        }
export type GetLatestExamEventOverviewReportCreatedAtQueryHookResult = ReturnType<typeof useGetLatestExamEventOverviewReportCreatedAtQuery>;
export type GetLatestExamEventOverviewReportCreatedAtLazyQueryHookResult = ReturnType<typeof useGetLatestExamEventOverviewReportCreatedAtLazyQuery>;
export type GetLatestExamEventOverviewReportCreatedAtSuspenseQueryHookResult = ReturnType<typeof useGetLatestExamEventOverviewReportCreatedAtSuspenseQuery>;
export type GetLatestExamEventOverviewReportCreatedAtQueryResult = Apollo.QueryResult<GetLatestExamEventOverviewReportCreatedAtQuery, GetLatestExamEventOverviewReportCreatedAtQueryVariables>;
export const GetAllProvincesDocument = gql`
    query getAllProvinces {
  reportGetAllProvinces {
    provinces {
      id
      nameTh
    }
  }
}
    `;

/**
 * __useGetAllProvincesQuery__
 *
 * To run a query within a React component, call `useGetAllProvincesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProvincesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProvincesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProvincesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProvincesQuery, GetAllProvincesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProvincesQuery, GetAllProvincesQueryVariables>(GetAllProvincesDocument, options);
      }
export function useGetAllProvincesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProvincesQuery, GetAllProvincesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProvincesQuery, GetAllProvincesQueryVariables>(GetAllProvincesDocument, options);
        }
// @ts-ignore
export function useGetAllProvincesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllProvincesQuery, GetAllProvincesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllProvincesQuery, GetAllProvincesQueryVariables>;
export function useGetAllProvincesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllProvincesQuery, GetAllProvincesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllProvincesQuery | undefined, GetAllProvincesQueryVariables>;
export function useGetAllProvincesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllProvincesQuery, GetAllProvincesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllProvincesQuery, GetAllProvincesQueryVariables>(GetAllProvincesDocument, options);
        }
export type GetAllProvincesQueryHookResult = ReturnType<typeof useGetAllProvincesQuery>;
export type GetAllProvincesLazyQueryHookResult = ReturnType<typeof useGetAllProvincesLazyQuery>;
export type GetAllProvincesSuspenseQueryHookResult = ReturnType<typeof useGetAllProvincesSuspenseQuery>;
export type GetAllProvincesQueryResult = Apollo.QueryResult<GetAllProvincesQuery, GetAllProvincesQueryVariables>;
export const GetLatestExamQSetUsageReportCreatedAtDocument = gql`
    query getLatestExamQSetUsageReportCreatedAt {
  reportGetLatestExamQSetUsageReportCreatedAt {
    latestCreatedAt
  }
}
    `;

/**
 * __useGetLatestExamQSetUsageReportCreatedAtQuery__
 *
 * To run a query within a React component, call `useGetLatestExamQSetUsageReportCreatedAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestExamQSetUsageReportCreatedAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestExamQSetUsageReportCreatedAtQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLatestExamQSetUsageReportCreatedAtQuery(baseOptions?: Apollo.QueryHookOptions<GetLatestExamQSetUsageReportCreatedAtQuery, GetLatestExamQSetUsageReportCreatedAtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestExamQSetUsageReportCreatedAtQuery, GetLatestExamQSetUsageReportCreatedAtQueryVariables>(GetLatestExamQSetUsageReportCreatedAtDocument, options);
      }
export function useGetLatestExamQSetUsageReportCreatedAtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestExamQSetUsageReportCreatedAtQuery, GetLatestExamQSetUsageReportCreatedAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestExamQSetUsageReportCreatedAtQuery, GetLatestExamQSetUsageReportCreatedAtQueryVariables>(GetLatestExamQSetUsageReportCreatedAtDocument, options);
        }
// @ts-ignore
export function useGetLatestExamQSetUsageReportCreatedAtSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLatestExamQSetUsageReportCreatedAtQuery, GetLatestExamQSetUsageReportCreatedAtQueryVariables>): Apollo.UseSuspenseQueryResult<GetLatestExamQSetUsageReportCreatedAtQuery, GetLatestExamQSetUsageReportCreatedAtQueryVariables>;
export function useGetLatestExamQSetUsageReportCreatedAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestExamQSetUsageReportCreatedAtQuery, GetLatestExamQSetUsageReportCreatedAtQueryVariables>): Apollo.UseSuspenseQueryResult<GetLatestExamQSetUsageReportCreatedAtQuery | undefined, GetLatestExamQSetUsageReportCreatedAtQueryVariables>;
export function useGetLatestExamQSetUsageReportCreatedAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestExamQSetUsageReportCreatedAtQuery, GetLatestExamQSetUsageReportCreatedAtQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestExamQSetUsageReportCreatedAtQuery, GetLatestExamQSetUsageReportCreatedAtQueryVariables>(GetLatestExamQSetUsageReportCreatedAtDocument, options);
        }
export type GetLatestExamQSetUsageReportCreatedAtQueryHookResult = ReturnType<typeof useGetLatestExamQSetUsageReportCreatedAtQuery>;
export type GetLatestExamQSetUsageReportCreatedAtLazyQueryHookResult = ReturnType<typeof useGetLatestExamQSetUsageReportCreatedAtLazyQuery>;
export type GetLatestExamQSetUsageReportCreatedAtSuspenseQueryHookResult = ReturnType<typeof useGetLatestExamQSetUsageReportCreatedAtSuspenseQuery>;
export type GetLatestExamQSetUsageReportCreatedAtQueryResult = Apollo.QueryResult<GetLatestExamQSetUsageReportCreatedAtQuery, GetLatestExamQSetUsageReportCreatedAtQueryVariables>;
export const GetSearchExamQSetUsageRecordsDocument = gql`
    query getSearchExamQSetUsageRecords($searchExamQSetUsageRecordsInput: SearchExamQSetUsageRecordsInput!) {
  reportSearchExamQSetUsageRecords(
    searchExamQSetUsageRecordsInput: $searchExamQSetUsageRecordsInput
  ) {
    total
    records {
      examCourseCode
      qSetCode
      qConfigRef
      startedAt
      endedAt
      pAverage
      examineeCount
      passedExamineeCount
      passedRate
      maxScore
      minScore
      averageScore
      standardDeviationScore
    }
  }
}
    `;

/**
 * __useGetSearchExamQSetUsageRecordsQuery__
 *
 * To run a query within a React component, call `useGetSearchExamQSetUsageRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchExamQSetUsageRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchExamQSetUsageRecordsQuery({
 *   variables: {
 *      searchExamQSetUsageRecordsInput: // value for 'searchExamQSetUsageRecordsInput'
 *   },
 * });
 */
export function useGetSearchExamQSetUsageRecordsQuery(baseOptions: Apollo.QueryHookOptions<GetSearchExamQSetUsageRecordsQuery, GetSearchExamQSetUsageRecordsQueryVariables> & ({ variables: GetSearchExamQSetUsageRecordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchExamQSetUsageRecordsQuery, GetSearchExamQSetUsageRecordsQueryVariables>(GetSearchExamQSetUsageRecordsDocument, options);
      }
export function useGetSearchExamQSetUsageRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchExamQSetUsageRecordsQuery, GetSearchExamQSetUsageRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchExamQSetUsageRecordsQuery, GetSearchExamQSetUsageRecordsQueryVariables>(GetSearchExamQSetUsageRecordsDocument, options);
        }
// @ts-ignore
export function useGetSearchExamQSetUsageRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSearchExamQSetUsageRecordsQuery, GetSearchExamQSetUsageRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSearchExamQSetUsageRecordsQuery, GetSearchExamQSetUsageRecordsQueryVariables>;
export function useGetSearchExamQSetUsageRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchExamQSetUsageRecordsQuery, GetSearchExamQSetUsageRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSearchExamQSetUsageRecordsQuery | undefined, GetSearchExamQSetUsageRecordsQueryVariables>;
export function useGetSearchExamQSetUsageRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchExamQSetUsageRecordsQuery, GetSearchExamQSetUsageRecordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchExamQSetUsageRecordsQuery, GetSearchExamQSetUsageRecordsQueryVariables>(GetSearchExamQSetUsageRecordsDocument, options);
        }
export type GetSearchExamQSetUsageRecordsQueryHookResult = ReturnType<typeof useGetSearchExamQSetUsageRecordsQuery>;
export type GetSearchExamQSetUsageRecordsLazyQueryHookResult = ReturnType<typeof useGetSearchExamQSetUsageRecordsLazyQuery>;
export type GetSearchExamQSetUsageRecordsSuspenseQueryHookResult = ReturnType<typeof useGetSearchExamQSetUsageRecordsSuspenseQuery>;
export type GetSearchExamQSetUsageRecordsQueryResult = Apollo.QueryResult<GetSearchExamQSetUsageRecordsQuery, GetSearchExamQSetUsageRecordsQueryVariables>;
export const ExportExamQSetUsageRecordsDocument = gql`
    query exportExamQSetUsageRecords($exportExamQSetUsageRecordsInput: ExportExamQSetUsageRecordsInput!) {
  reportExportExamQSetUsageRecords(
    exportExamQSetUsageRecordsInput: $exportExamQSetUsageRecordsInput
  ) {
    signedUrl
  }
}
    `;

/**
 * __useExportExamQSetUsageRecordsQuery__
 *
 * To run a query within a React component, call `useExportExamQSetUsageRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportExamQSetUsageRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportExamQSetUsageRecordsQuery({
 *   variables: {
 *      exportExamQSetUsageRecordsInput: // value for 'exportExamQSetUsageRecordsInput'
 *   },
 * });
 */
export function useExportExamQSetUsageRecordsQuery(baseOptions: Apollo.QueryHookOptions<ExportExamQSetUsageRecordsQuery, ExportExamQSetUsageRecordsQueryVariables> & ({ variables: ExportExamQSetUsageRecordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportExamQSetUsageRecordsQuery, ExportExamQSetUsageRecordsQueryVariables>(ExportExamQSetUsageRecordsDocument, options);
      }
export function useExportExamQSetUsageRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportExamQSetUsageRecordsQuery, ExportExamQSetUsageRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportExamQSetUsageRecordsQuery, ExportExamQSetUsageRecordsQueryVariables>(ExportExamQSetUsageRecordsDocument, options);
        }
// @ts-ignore
export function useExportExamQSetUsageRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportExamQSetUsageRecordsQuery, ExportExamQSetUsageRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportExamQSetUsageRecordsQuery, ExportExamQSetUsageRecordsQueryVariables>;
export function useExportExamQSetUsageRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportExamQSetUsageRecordsQuery, ExportExamQSetUsageRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportExamQSetUsageRecordsQuery | undefined, ExportExamQSetUsageRecordsQueryVariables>;
export function useExportExamQSetUsageRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportExamQSetUsageRecordsQuery, ExportExamQSetUsageRecordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportExamQSetUsageRecordsQuery, ExportExamQSetUsageRecordsQueryVariables>(ExportExamQSetUsageRecordsDocument, options);
        }
export type ExportExamQSetUsageRecordsQueryHookResult = ReturnType<typeof useExportExamQSetUsageRecordsQuery>;
export type ExportExamQSetUsageRecordsLazyQueryHookResult = ReturnType<typeof useExportExamQSetUsageRecordsLazyQuery>;
export type ExportExamQSetUsageRecordsSuspenseQueryHookResult = ReturnType<typeof useExportExamQSetUsageRecordsSuspenseQuery>;
export type ExportExamQSetUsageRecordsQueryResult = Apollo.QueryResult<ExportExamQSetUsageRecordsQuery, ExportExamQSetUsageRecordsQueryVariables>;
export const SearchQuestionItemAnalysisYearlyRecordsDocument = gql`
    query searchQuestionItemAnalysisYearlyRecords($searchQuestionItemAnalysisYearlyRecordsInput: SearchQuestionItemAnalysisYearlyRecordsInput!) {
  reportSearchQuestionItemAnalysisYearlyRecords(
    searchQuestionItemAnalysisYearlyRecordsInput: $searchQuestionItemAnalysisYearlyRecordsInput
  ) {
    records {
      questionId
      questionRefCode
      firstPublishedAt
      lastPublishedAt
      calculated
      status
      pInitial
      pUsed
      bIndexInitial
      yearlyQuestionItems {
        year
        totalExaminees
        pCalculated
        bIndex
      }
      summaryQuestionItem {
        totalExaminees
        pCalculated
        bIndex
      }
    }
    total
  }
}
    `;

/**
 * __useSearchQuestionItemAnalysisYearlyRecordsQuery__
 *
 * To run a query within a React component, call `useSearchQuestionItemAnalysisYearlyRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuestionItemAnalysisYearlyRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuestionItemAnalysisYearlyRecordsQuery({
 *   variables: {
 *      searchQuestionItemAnalysisYearlyRecordsInput: // value for 'searchQuestionItemAnalysisYearlyRecordsInput'
 *   },
 * });
 */
export function useSearchQuestionItemAnalysisYearlyRecordsQuery(baseOptions: Apollo.QueryHookOptions<SearchQuestionItemAnalysisYearlyRecordsQuery, SearchQuestionItemAnalysisYearlyRecordsQueryVariables> & ({ variables: SearchQuestionItemAnalysisYearlyRecordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuestionItemAnalysisYearlyRecordsQuery, SearchQuestionItemAnalysisYearlyRecordsQueryVariables>(SearchQuestionItemAnalysisYearlyRecordsDocument, options);
      }
export function useSearchQuestionItemAnalysisYearlyRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuestionItemAnalysisYearlyRecordsQuery, SearchQuestionItemAnalysisYearlyRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuestionItemAnalysisYearlyRecordsQuery, SearchQuestionItemAnalysisYearlyRecordsQueryVariables>(SearchQuestionItemAnalysisYearlyRecordsDocument, options);
        }
// @ts-ignore
export function useSearchQuestionItemAnalysisYearlyRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQuestionItemAnalysisYearlyRecordsQuery, SearchQuestionItemAnalysisYearlyRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuestionItemAnalysisYearlyRecordsQuery, SearchQuestionItemAnalysisYearlyRecordsQueryVariables>;
export function useSearchQuestionItemAnalysisYearlyRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuestionItemAnalysisYearlyRecordsQuery, SearchQuestionItemAnalysisYearlyRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuestionItemAnalysisYearlyRecordsQuery | undefined, SearchQuestionItemAnalysisYearlyRecordsQueryVariables>;
export function useSearchQuestionItemAnalysisYearlyRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuestionItemAnalysisYearlyRecordsQuery, SearchQuestionItemAnalysisYearlyRecordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQuestionItemAnalysisYearlyRecordsQuery, SearchQuestionItemAnalysisYearlyRecordsQueryVariables>(SearchQuestionItemAnalysisYearlyRecordsDocument, options);
        }
export type SearchQuestionItemAnalysisYearlyRecordsQueryHookResult = ReturnType<typeof useSearchQuestionItemAnalysisYearlyRecordsQuery>;
export type SearchQuestionItemAnalysisYearlyRecordsLazyQueryHookResult = ReturnType<typeof useSearchQuestionItemAnalysisYearlyRecordsLazyQuery>;
export type SearchQuestionItemAnalysisYearlyRecordsSuspenseQueryHookResult = ReturnType<typeof useSearchQuestionItemAnalysisYearlyRecordsSuspenseQuery>;
export type SearchQuestionItemAnalysisYearlyRecordsQueryResult = Apollo.QueryResult<SearchQuestionItemAnalysisYearlyRecordsQuery, SearchQuestionItemAnalysisYearlyRecordsQueryVariables>;
export const ExportQuestionItemAnalysisYearlyRecordsDocument = gql`
    query exportQuestionItemAnalysisYearlyRecords($exportQuestionItemAnalysisYearlyRecordsInput: ExportQuestionItemAnalysisYearlyRecordsInput!) {
  reportExportQuestionItemAnalysisYearlyRecords(
    exportQuestionItemAnalysisYearlyRecordsInput: $exportQuestionItemAnalysisYearlyRecordsInput
  ) {
    signedUrl
  }
}
    `;

/**
 * __useExportQuestionItemAnalysisYearlyRecordsQuery__
 *
 * To run a query within a React component, call `useExportQuestionItemAnalysisYearlyRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportQuestionItemAnalysisYearlyRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportQuestionItemAnalysisYearlyRecordsQuery({
 *   variables: {
 *      exportQuestionItemAnalysisYearlyRecordsInput: // value for 'exportQuestionItemAnalysisYearlyRecordsInput'
 *   },
 * });
 */
export function useExportQuestionItemAnalysisYearlyRecordsQuery(baseOptions: Apollo.QueryHookOptions<ExportQuestionItemAnalysisYearlyRecordsQuery, ExportQuestionItemAnalysisYearlyRecordsQueryVariables> & ({ variables: ExportQuestionItemAnalysisYearlyRecordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportQuestionItemAnalysisYearlyRecordsQuery, ExportQuestionItemAnalysisYearlyRecordsQueryVariables>(ExportQuestionItemAnalysisYearlyRecordsDocument, options);
      }
export function useExportQuestionItemAnalysisYearlyRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportQuestionItemAnalysisYearlyRecordsQuery, ExportQuestionItemAnalysisYearlyRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportQuestionItemAnalysisYearlyRecordsQuery, ExportQuestionItemAnalysisYearlyRecordsQueryVariables>(ExportQuestionItemAnalysisYearlyRecordsDocument, options);
        }
// @ts-ignore
export function useExportQuestionItemAnalysisYearlyRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportQuestionItemAnalysisYearlyRecordsQuery, ExportQuestionItemAnalysisYearlyRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportQuestionItemAnalysisYearlyRecordsQuery, ExportQuestionItemAnalysisYearlyRecordsQueryVariables>;
export function useExportQuestionItemAnalysisYearlyRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportQuestionItemAnalysisYearlyRecordsQuery, ExportQuestionItemAnalysisYearlyRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportQuestionItemAnalysisYearlyRecordsQuery | undefined, ExportQuestionItemAnalysisYearlyRecordsQueryVariables>;
export function useExportQuestionItemAnalysisYearlyRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportQuestionItemAnalysisYearlyRecordsQuery, ExportQuestionItemAnalysisYearlyRecordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportQuestionItemAnalysisYearlyRecordsQuery, ExportQuestionItemAnalysisYearlyRecordsQueryVariables>(ExportQuestionItemAnalysisYearlyRecordsDocument, options);
        }
export type ExportQuestionItemAnalysisYearlyRecordsQueryHookResult = ReturnType<typeof useExportQuestionItemAnalysisYearlyRecordsQuery>;
export type ExportQuestionItemAnalysisYearlyRecordsLazyQueryHookResult = ReturnType<typeof useExportQuestionItemAnalysisYearlyRecordsLazyQuery>;
export type ExportQuestionItemAnalysisYearlyRecordsSuspenseQueryHookResult = ReturnType<typeof useExportQuestionItemAnalysisYearlyRecordsSuspenseQuery>;
export type ExportQuestionItemAnalysisYearlyRecordsQueryResult = Apollo.QueryResult<ExportQuestionItemAnalysisYearlyRecordsQuery, ExportQuestionItemAnalysisYearlyRecordsQueryVariables>;
export const GetLatestQuestionItemAnalysisYearlyReportCreatedAtDocument = gql`
    query getLatestQuestionItemAnalysisYearlyReportCreatedAt {
  reportGetLatestQuestionItemAnalysisYearlyReportCreatedAt {
    latestCreatedAt
  }
}
    `;

/**
 * __useGetLatestQuestionItemAnalysisYearlyReportCreatedAtQuery__
 *
 * To run a query within a React component, call `useGetLatestQuestionItemAnalysisYearlyReportCreatedAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestQuestionItemAnalysisYearlyReportCreatedAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestQuestionItemAnalysisYearlyReportCreatedAtQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLatestQuestionItemAnalysisYearlyReportCreatedAtQuery(baseOptions?: Apollo.QueryHookOptions<GetLatestQuestionItemAnalysisYearlyReportCreatedAtQuery, GetLatestQuestionItemAnalysisYearlyReportCreatedAtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestQuestionItemAnalysisYearlyReportCreatedAtQuery, GetLatestQuestionItemAnalysisYearlyReportCreatedAtQueryVariables>(GetLatestQuestionItemAnalysisYearlyReportCreatedAtDocument, options);
      }
export function useGetLatestQuestionItemAnalysisYearlyReportCreatedAtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestQuestionItemAnalysisYearlyReportCreatedAtQuery, GetLatestQuestionItemAnalysisYearlyReportCreatedAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestQuestionItemAnalysisYearlyReportCreatedAtQuery, GetLatestQuestionItemAnalysisYearlyReportCreatedAtQueryVariables>(GetLatestQuestionItemAnalysisYearlyReportCreatedAtDocument, options);
        }
// @ts-ignore
export function useGetLatestQuestionItemAnalysisYearlyReportCreatedAtSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLatestQuestionItemAnalysisYearlyReportCreatedAtQuery, GetLatestQuestionItemAnalysisYearlyReportCreatedAtQueryVariables>): Apollo.UseSuspenseQueryResult<GetLatestQuestionItemAnalysisYearlyReportCreatedAtQuery, GetLatestQuestionItemAnalysisYearlyReportCreatedAtQueryVariables>;
export function useGetLatestQuestionItemAnalysisYearlyReportCreatedAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestQuestionItemAnalysisYearlyReportCreatedAtQuery, GetLatestQuestionItemAnalysisYearlyReportCreatedAtQueryVariables>): Apollo.UseSuspenseQueryResult<GetLatestQuestionItemAnalysisYearlyReportCreatedAtQuery | undefined, GetLatestQuestionItemAnalysisYearlyReportCreatedAtQueryVariables>;
export function useGetLatestQuestionItemAnalysisYearlyReportCreatedAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestQuestionItemAnalysisYearlyReportCreatedAtQuery, GetLatestQuestionItemAnalysisYearlyReportCreatedAtQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestQuestionItemAnalysisYearlyReportCreatedAtQuery, GetLatestQuestionItemAnalysisYearlyReportCreatedAtQueryVariables>(GetLatestQuestionItemAnalysisYearlyReportCreatedAtDocument, options);
        }
export type GetLatestQuestionItemAnalysisYearlyReportCreatedAtQueryHookResult = ReturnType<typeof useGetLatestQuestionItemAnalysisYearlyReportCreatedAtQuery>;
export type GetLatestQuestionItemAnalysisYearlyReportCreatedAtLazyQueryHookResult = ReturnType<typeof useGetLatestQuestionItemAnalysisYearlyReportCreatedAtLazyQuery>;
export type GetLatestQuestionItemAnalysisYearlyReportCreatedAtSuspenseQueryHookResult = ReturnType<typeof useGetLatestQuestionItemAnalysisYearlyReportCreatedAtSuspenseQuery>;
export type GetLatestQuestionItemAnalysisYearlyReportCreatedAtQueryResult = Apollo.QueryResult<GetLatestQuestionItemAnalysisYearlyReportCreatedAtQuery, GetLatestQuestionItemAnalysisYearlyReportCreatedAtQueryVariables>;
export const SearchQuestionItemAnalysisRecordsDocument = gql`
    query searchQuestionItemAnalysisRecords($searchQuestionItemAnalysisRecordsInput: SearchQuestionItemAnalysisRecordsInput!) {
  reportSearchQuestionItemAnalysisRecords(
    searchQuestionItemAnalysisRecordsInput: $searchQuestionItemAnalysisRecordsInput
  ) {
    records {
      questionId
      questionRefCode
      firstPublishedAt
      lastPublishedAt
      calculated
      status
      pInitial
      pUse
      bIndexInitial
      answer
      numbersOfPassed {
        answer
        total
      }
      numbersOfFailed {
        answer
        total
      }
      numbersOfExaminees {
        answer
        total
      }
      percentageOfAnswered {
        answer
        total
      }
      totalNumberOfPassed
      totalNumberOfFailed
      totalExaminees
      bIndex
      pCalculated
    }
    total
  }
}
    `;

/**
 * __useSearchQuestionItemAnalysisRecordsQuery__
 *
 * To run a query within a React component, call `useSearchQuestionItemAnalysisRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuestionItemAnalysisRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuestionItemAnalysisRecordsQuery({
 *   variables: {
 *      searchQuestionItemAnalysisRecordsInput: // value for 'searchQuestionItemAnalysisRecordsInput'
 *   },
 * });
 */
export function useSearchQuestionItemAnalysisRecordsQuery(baseOptions: Apollo.QueryHookOptions<SearchQuestionItemAnalysisRecordsQuery, SearchQuestionItemAnalysisRecordsQueryVariables> & ({ variables: SearchQuestionItemAnalysisRecordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuestionItemAnalysisRecordsQuery, SearchQuestionItemAnalysisRecordsQueryVariables>(SearchQuestionItemAnalysisRecordsDocument, options);
      }
export function useSearchQuestionItemAnalysisRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuestionItemAnalysisRecordsQuery, SearchQuestionItemAnalysisRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuestionItemAnalysisRecordsQuery, SearchQuestionItemAnalysisRecordsQueryVariables>(SearchQuestionItemAnalysisRecordsDocument, options);
        }
// @ts-ignore
export function useSearchQuestionItemAnalysisRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQuestionItemAnalysisRecordsQuery, SearchQuestionItemAnalysisRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuestionItemAnalysisRecordsQuery, SearchQuestionItemAnalysisRecordsQueryVariables>;
export function useSearchQuestionItemAnalysisRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuestionItemAnalysisRecordsQuery, SearchQuestionItemAnalysisRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuestionItemAnalysisRecordsQuery | undefined, SearchQuestionItemAnalysisRecordsQueryVariables>;
export function useSearchQuestionItemAnalysisRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuestionItemAnalysisRecordsQuery, SearchQuestionItemAnalysisRecordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQuestionItemAnalysisRecordsQuery, SearchQuestionItemAnalysisRecordsQueryVariables>(SearchQuestionItemAnalysisRecordsDocument, options);
        }
export type SearchQuestionItemAnalysisRecordsQueryHookResult = ReturnType<typeof useSearchQuestionItemAnalysisRecordsQuery>;
export type SearchQuestionItemAnalysisRecordsLazyQueryHookResult = ReturnType<typeof useSearchQuestionItemAnalysisRecordsLazyQuery>;
export type SearchQuestionItemAnalysisRecordsSuspenseQueryHookResult = ReturnType<typeof useSearchQuestionItemAnalysisRecordsSuspenseQuery>;
export type SearchQuestionItemAnalysisRecordsQueryResult = Apollo.QueryResult<SearchQuestionItemAnalysisRecordsQuery, SearchQuestionItemAnalysisRecordsQueryVariables>;
export const GetAllQBankStructuresDocument = gql`
    query getAllQBankStructures($getAllQBankStructuresInput: GetAllQBankStructuresInput!) {
  reportGetAllQBankStructures(
    GetAllQBankStructuresInput: $getAllQBankStructuresInput
  ) {
    qBankStructures {
      id
      name
      code
    }
  }
}
    `;

/**
 * __useGetAllQBankStructuresQuery__
 *
 * To run a query within a React component, call `useGetAllQBankStructuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllQBankStructuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllQBankStructuresQuery({
 *   variables: {
 *      getAllQBankStructuresInput: // value for 'getAllQBankStructuresInput'
 *   },
 * });
 */
export function useGetAllQBankStructuresQuery(baseOptions: Apollo.QueryHookOptions<GetAllQBankStructuresQuery, GetAllQBankStructuresQueryVariables> & ({ variables: GetAllQBankStructuresQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllQBankStructuresQuery, GetAllQBankStructuresQueryVariables>(GetAllQBankStructuresDocument, options);
      }
export function useGetAllQBankStructuresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllQBankStructuresQuery, GetAllQBankStructuresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllQBankStructuresQuery, GetAllQBankStructuresQueryVariables>(GetAllQBankStructuresDocument, options);
        }
// @ts-ignore
export function useGetAllQBankStructuresSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllQBankStructuresQuery, GetAllQBankStructuresQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllQBankStructuresQuery, GetAllQBankStructuresQueryVariables>;
export function useGetAllQBankStructuresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllQBankStructuresQuery, GetAllQBankStructuresQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllQBankStructuresQuery | undefined, GetAllQBankStructuresQueryVariables>;
export function useGetAllQBankStructuresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllQBankStructuresQuery, GetAllQBankStructuresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllQBankStructuresQuery, GetAllQBankStructuresQueryVariables>(GetAllQBankStructuresDocument, options);
        }
export type GetAllQBankStructuresQueryHookResult = ReturnType<typeof useGetAllQBankStructuresQuery>;
export type GetAllQBankStructuresLazyQueryHookResult = ReturnType<typeof useGetAllQBankStructuresLazyQuery>;
export type GetAllQBankStructuresSuspenseQueryHookResult = ReturnType<typeof useGetAllQBankStructuresSuspenseQuery>;
export type GetAllQBankStructuresQueryResult = Apollo.QueryResult<GetAllQBankStructuresQuery, GetAllQBankStructuresQueryVariables>;
export const GetPAnalysisCellsDocument = gql`
    query getPAnalysisCells($getPAnalysisCellsInput: GetPAnalysisCellsInput!) {
  reportGetPAnalysisCells(getPAnalysisCellsInput: $getPAnalysisCellsInput) {
    cells {
      pUsedDifficulty
      pCalculatedWithThresholdDifficulty
      totalQuestions
    }
    total
  }
}
    `;

/**
 * __useGetPAnalysisCellsQuery__
 *
 * To run a query within a React component, call `useGetPAnalysisCellsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPAnalysisCellsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPAnalysisCellsQuery({
 *   variables: {
 *      getPAnalysisCellsInput: // value for 'getPAnalysisCellsInput'
 *   },
 * });
 */
export function useGetPAnalysisCellsQuery(baseOptions: Apollo.QueryHookOptions<GetPAnalysisCellsQuery, GetPAnalysisCellsQueryVariables> & ({ variables: GetPAnalysisCellsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPAnalysisCellsQuery, GetPAnalysisCellsQueryVariables>(GetPAnalysisCellsDocument, options);
      }
export function useGetPAnalysisCellsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPAnalysisCellsQuery, GetPAnalysisCellsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPAnalysisCellsQuery, GetPAnalysisCellsQueryVariables>(GetPAnalysisCellsDocument, options);
        }
// @ts-ignore
export function useGetPAnalysisCellsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPAnalysisCellsQuery, GetPAnalysisCellsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPAnalysisCellsQuery, GetPAnalysisCellsQueryVariables>;
export function useGetPAnalysisCellsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPAnalysisCellsQuery, GetPAnalysisCellsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPAnalysisCellsQuery | undefined, GetPAnalysisCellsQueryVariables>;
export function useGetPAnalysisCellsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPAnalysisCellsQuery, GetPAnalysisCellsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPAnalysisCellsQuery, GetPAnalysisCellsQueryVariables>(GetPAnalysisCellsDocument, options);
        }
export type GetPAnalysisCellsQueryHookResult = ReturnType<typeof useGetPAnalysisCellsQuery>;
export type GetPAnalysisCellsLazyQueryHookResult = ReturnType<typeof useGetPAnalysisCellsLazyQuery>;
export type GetPAnalysisCellsSuspenseQueryHookResult = ReturnType<typeof useGetPAnalysisCellsSuspenseQuery>;
export type GetPAnalysisCellsQueryResult = Apollo.QueryResult<GetPAnalysisCellsQuery, GetPAnalysisCellsQueryVariables>;
export const AdjustQuestionsPValuesDocument = gql`
    mutation adjustQuestionsPValues($adjustQuestionsPValuesInput: AdjustQuestionsPValuesInput!) {
  reportAdjustQuestionsPValues(
    adjustQuestionsPValuesInput: $adjustQuestionsPValuesInput
  ) {
    status
    message
  }
}
    `;
export type AdjustQuestionsPValuesMutationFn = Apollo.MutationFunction<AdjustQuestionsPValuesMutation, AdjustQuestionsPValuesMutationVariables>;

/**
 * __useAdjustQuestionsPValuesMutation__
 *
 * To run a mutation, you first call `useAdjustQuestionsPValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdjustQuestionsPValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adjustQuestionsPValuesMutation, { data, loading, error }] = useAdjustQuestionsPValuesMutation({
 *   variables: {
 *      adjustQuestionsPValuesInput: // value for 'adjustQuestionsPValuesInput'
 *   },
 * });
 */
export function useAdjustQuestionsPValuesMutation(baseOptions?: Apollo.MutationHookOptions<AdjustQuestionsPValuesMutation, AdjustQuestionsPValuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdjustQuestionsPValuesMutation, AdjustQuestionsPValuesMutationVariables>(AdjustQuestionsPValuesDocument, options);
      }
export type AdjustQuestionsPValuesMutationHookResult = ReturnType<typeof useAdjustQuestionsPValuesMutation>;
export type AdjustQuestionsPValuesMutationResult = Apollo.MutationResult<AdjustQuestionsPValuesMutation>;
export type AdjustQuestionsPValuesMutationOptions = Apollo.BaseMutationOptions<AdjustQuestionsPValuesMutation, AdjustQuestionsPValuesMutationVariables>;
export const ExportQuestionItemAnalysisRecordsDocument = gql`
    query exportQuestionItemAnalysisRecords($exportQuestionItemAnalysisRecordsInput: ExportQuestionItemAnalysisRecordsInput!) {
  reportExportQuestionItemAnalysisRecords(
    exportQuestionItemAnalysisRecordsInput: $exportQuestionItemAnalysisRecordsInput
  ) {
    signedUrl
  }
}
    `;

/**
 * __useExportQuestionItemAnalysisRecordsQuery__
 *
 * To run a query within a React component, call `useExportQuestionItemAnalysisRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportQuestionItemAnalysisRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportQuestionItemAnalysisRecordsQuery({
 *   variables: {
 *      exportQuestionItemAnalysisRecordsInput: // value for 'exportQuestionItemAnalysisRecordsInput'
 *   },
 * });
 */
export function useExportQuestionItemAnalysisRecordsQuery(baseOptions: Apollo.QueryHookOptions<ExportQuestionItemAnalysisRecordsQuery, ExportQuestionItemAnalysisRecordsQueryVariables> & ({ variables: ExportQuestionItemAnalysisRecordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportQuestionItemAnalysisRecordsQuery, ExportQuestionItemAnalysisRecordsQueryVariables>(ExportQuestionItemAnalysisRecordsDocument, options);
      }
export function useExportQuestionItemAnalysisRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportQuestionItemAnalysisRecordsQuery, ExportQuestionItemAnalysisRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportQuestionItemAnalysisRecordsQuery, ExportQuestionItemAnalysisRecordsQueryVariables>(ExportQuestionItemAnalysisRecordsDocument, options);
        }
// @ts-ignore
export function useExportQuestionItemAnalysisRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportQuestionItemAnalysisRecordsQuery, ExportQuestionItemAnalysisRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportQuestionItemAnalysisRecordsQuery, ExportQuestionItemAnalysisRecordsQueryVariables>;
export function useExportQuestionItemAnalysisRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportQuestionItemAnalysisRecordsQuery, ExportQuestionItemAnalysisRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportQuestionItemAnalysisRecordsQuery | undefined, ExportQuestionItemAnalysisRecordsQueryVariables>;
export function useExportQuestionItemAnalysisRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportQuestionItemAnalysisRecordsQuery, ExportQuestionItemAnalysisRecordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportQuestionItemAnalysisRecordsQuery, ExportQuestionItemAnalysisRecordsQueryVariables>(ExportQuestionItemAnalysisRecordsDocument, options);
        }
export type ExportQuestionItemAnalysisRecordsQueryHookResult = ReturnType<typeof useExportQuestionItemAnalysisRecordsQuery>;
export type ExportQuestionItemAnalysisRecordsLazyQueryHookResult = ReturnType<typeof useExportQuestionItemAnalysisRecordsLazyQuery>;
export type ExportQuestionItemAnalysisRecordsSuspenseQueryHookResult = ReturnType<typeof useExportQuestionItemAnalysisRecordsSuspenseQuery>;
export type ExportQuestionItemAnalysisRecordsQueryResult = Apollo.QueryResult<ExportQuestionItemAnalysisRecordsQuery, ExportQuestionItemAnalysisRecordsQueryVariables>;
export const GetLatestQuestionItemAnalysisReportCreatedAtDocument = gql`
    query getLatestQuestionItemAnalysisReportCreatedAt {
  reportGetLatestQuestionItemAnalysisReportCreatedAt {
    latestCreatedAt
  }
}
    `;

/**
 * __useGetLatestQuestionItemAnalysisReportCreatedAtQuery__
 *
 * To run a query within a React component, call `useGetLatestQuestionItemAnalysisReportCreatedAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestQuestionItemAnalysisReportCreatedAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestQuestionItemAnalysisReportCreatedAtQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLatestQuestionItemAnalysisReportCreatedAtQuery(baseOptions?: Apollo.QueryHookOptions<GetLatestQuestionItemAnalysisReportCreatedAtQuery, GetLatestQuestionItemAnalysisReportCreatedAtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestQuestionItemAnalysisReportCreatedAtQuery, GetLatestQuestionItemAnalysisReportCreatedAtQueryVariables>(GetLatestQuestionItemAnalysisReportCreatedAtDocument, options);
      }
export function useGetLatestQuestionItemAnalysisReportCreatedAtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestQuestionItemAnalysisReportCreatedAtQuery, GetLatestQuestionItemAnalysisReportCreatedAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestQuestionItemAnalysisReportCreatedAtQuery, GetLatestQuestionItemAnalysisReportCreatedAtQueryVariables>(GetLatestQuestionItemAnalysisReportCreatedAtDocument, options);
        }
// @ts-ignore
export function useGetLatestQuestionItemAnalysisReportCreatedAtSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLatestQuestionItemAnalysisReportCreatedAtQuery, GetLatestQuestionItemAnalysisReportCreatedAtQueryVariables>): Apollo.UseSuspenseQueryResult<GetLatestQuestionItemAnalysisReportCreatedAtQuery, GetLatestQuestionItemAnalysisReportCreatedAtQueryVariables>;
export function useGetLatestQuestionItemAnalysisReportCreatedAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestQuestionItemAnalysisReportCreatedAtQuery, GetLatestQuestionItemAnalysisReportCreatedAtQueryVariables>): Apollo.UseSuspenseQueryResult<GetLatestQuestionItemAnalysisReportCreatedAtQuery | undefined, GetLatestQuestionItemAnalysisReportCreatedAtQueryVariables>;
export function useGetLatestQuestionItemAnalysisReportCreatedAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestQuestionItemAnalysisReportCreatedAtQuery, GetLatestQuestionItemAnalysisReportCreatedAtQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestQuestionItemAnalysisReportCreatedAtQuery, GetLatestQuestionItemAnalysisReportCreatedAtQueryVariables>(GetLatestQuestionItemAnalysisReportCreatedAtDocument, options);
        }
export type GetLatestQuestionItemAnalysisReportCreatedAtQueryHookResult = ReturnType<typeof useGetLatestQuestionItemAnalysisReportCreatedAtQuery>;
export type GetLatestQuestionItemAnalysisReportCreatedAtLazyQueryHookResult = ReturnType<typeof useGetLatestQuestionItemAnalysisReportCreatedAtLazyQuery>;
export type GetLatestQuestionItemAnalysisReportCreatedAtSuspenseQueryHookResult = ReturnType<typeof useGetLatestQuestionItemAnalysisReportCreatedAtSuspenseQuery>;
export type GetLatestQuestionItemAnalysisReportCreatedAtQueryResult = Apollo.QueryResult<GetLatestQuestionItemAnalysisReportCreatedAtQuery, GetLatestQuestionItemAnalysisReportCreatedAtQueryVariables>;
export const SearchQuestionQSetUsageRecordsDocument = gql`
    query searchQuestionQSetUsageRecords($searchQuestionQSetUsageRecordsInput: SearchQuestionQSetUsageRecordsInput!) {
  reportSearchQuestionQSetUsageRecords(
    searchQuestionQSetUsageRecordsInput: $searchQuestionQSetUsageRecordsInput
  ) {
    records {
      questionId
      questionRefCode
      calculated
      pInitial
      pUsed
      bIndexInitial
      qSetUsages {
        qSetCodeNumber
        isUsed
      }
    }
    total
  }
}
    `;

/**
 * __useSearchQuestionQSetUsageRecordsQuery__
 *
 * To run a query within a React component, call `useSearchQuestionQSetUsageRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuestionQSetUsageRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuestionQSetUsageRecordsQuery({
 *   variables: {
 *      searchQuestionQSetUsageRecordsInput: // value for 'searchQuestionQSetUsageRecordsInput'
 *   },
 * });
 */
export function useSearchQuestionQSetUsageRecordsQuery(baseOptions: Apollo.QueryHookOptions<SearchQuestionQSetUsageRecordsQuery, SearchQuestionQSetUsageRecordsQueryVariables> & ({ variables: SearchQuestionQSetUsageRecordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuestionQSetUsageRecordsQuery, SearchQuestionQSetUsageRecordsQueryVariables>(SearchQuestionQSetUsageRecordsDocument, options);
      }
export function useSearchQuestionQSetUsageRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuestionQSetUsageRecordsQuery, SearchQuestionQSetUsageRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuestionQSetUsageRecordsQuery, SearchQuestionQSetUsageRecordsQueryVariables>(SearchQuestionQSetUsageRecordsDocument, options);
        }
// @ts-ignore
export function useSearchQuestionQSetUsageRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQuestionQSetUsageRecordsQuery, SearchQuestionQSetUsageRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuestionQSetUsageRecordsQuery, SearchQuestionQSetUsageRecordsQueryVariables>;
export function useSearchQuestionQSetUsageRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuestionQSetUsageRecordsQuery, SearchQuestionQSetUsageRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuestionQSetUsageRecordsQuery | undefined, SearchQuestionQSetUsageRecordsQueryVariables>;
export function useSearchQuestionQSetUsageRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuestionQSetUsageRecordsQuery, SearchQuestionQSetUsageRecordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQuestionQSetUsageRecordsQuery, SearchQuestionQSetUsageRecordsQueryVariables>(SearchQuestionQSetUsageRecordsDocument, options);
        }
export type SearchQuestionQSetUsageRecordsQueryHookResult = ReturnType<typeof useSearchQuestionQSetUsageRecordsQuery>;
export type SearchQuestionQSetUsageRecordsLazyQueryHookResult = ReturnType<typeof useSearchQuestionQSetUsageRecordsLazyQuery>;
export type SearchQuestionQSetUsageRecordsSuspenseQueryHookResult = ReturnType<typeof useSearchQuestionQSetUsageRecordsSuspenseQuery>;
export type SearchQuestionQSetUsageRecordsQueryResult = Apollo.QueryResult<SearchQuestionQSetUsageRecordsQuery, SearchQuestionQSetUsageRecordsQueryVariables>;
export const ExportQuestionQSetUsageRecordsDocument = gql`
    query exportQuestionQSetUsageRecords($exportQuestionQSetUsageRecordsInput: ExportQuestionQSetUsageRecordsInput!) {
  reportExportQuestionQSetUsageRecords(
    exportQuestionQSetUsageRecordsInput: $exportQuestionQSetUsageRecordsInput
  ) {
    signedUrl
  }
}
    `;

/**
 * __useExportQuestionQSetUsageRecordsQuery__
 *
 * To run a query within a React component, call `useExportQuestionQSetUsageRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportQuestionQSetUsageRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportQuestionQSetUsageRecordsQuery({
 *   variables: {
 *      exportQuestionQSetUsageRecordsInput: // value for 'exportQuestionQSetUsageRecordsInput'
 *   },
 * });
 */
export function useExportQuestionQSetUsageRecordsQuery(baseOptions: Apollo.QueryHookOptions<ExportQuestionQSetUsageRecordsQuery, ExportQuestionQSetUsageRecordsQueryVariables> & ({ variables: ExportQuestionQSetUsageRecordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportQuestionQSetUsageRecordsQuery, ExportQuestionQSetUsageRecordsQueryVariables>(ExportQuestionQSetUsageRecordsDocument, options);
      }
export function useExportQuestionQSetUsageRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportQuestionQSetUsageRecordsQuery, ExportQuestionQSetUsageRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportQuestionQSetUsageRecordsQuery, ExportQuestionQSetUsageRecordsQueryVariables>(ExportQuestionQSetUsageRecordsDocument, options);
        }
// @ts-ignore
export function useExportQuestionQSetUsageRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportQuestionQSetUsageRecordsQuery, ExportQuestionQSetUsageRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportQuestionQSetUsageRecordsQuery, ExportQuestionQSetUsageRecordsQueryVariables>;
export function useExportQuestionQSetUsageRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportQuestionQSetUsageRecordsQuery, ExportQuestionQSetUsageRecordsQueryVariables>): Apollo.UseSuspenseQueryResult<ExportQuestionQSetUsageRecordsQuery | undefined, ExportQuestionQSetUsageRecordsQueryVariables>;
export function useExportQuestionQSetUsageRecordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportQuestionQSetUsageRecordsQuery, ExportQuestionQSetUsageRecordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportQuestionQSetUsageRecordsQuery, ExportQuestionQSetUsageRecordsQueryVariables>(ExportQuestionQSetUsageRecordsDocument, options);
        }
export type ExportQuestionQSetUsageRecordsQueryHookResult = ReturnType<typeof useExportQuestionQSetUsageRecordsQuery>;
export type ExportQuestionQSetUsageRecordsLazyQueryHookResult = ReturnType<typeof useExportQuestionQSetUsageRecordsLazyQuery>;
export type ExportQuestionQSetUsageRecordsSuspenseQueryHookResult = ReturnType<typeof useExportQuestionQSetUsageRecordsSuspenseQuery>;
export type ExportQuestionQSetUsageRecordsQueryResult = Apollo.QueryResult<ExportQuestionQSetUsageRecordsQuery, ExportQuestionQSetUsageRecordsQueryVariables>;
export const GetLatestQuestionQSetUsageReportUpdatedAtDocument = gql`
    query getLatestQuestionQSetUsageReportUpdatedAt {
  reportGetLatestQuestionQSetUsageReportUpdatedAt {
    latestUpdatedAt
  }
}
    `;

/**
 * __useGetLatestQuestionQSetUsageReportUpdatedAtQuery__
 *
 * To run a query within a React component, call `useGetLatestQuestionQSetUsageReportUpdatedAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestQuestionQSetUsageReportUpdatedAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestQuestionQSetUsageReportUpdatedAtQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLatestQuestionQSetUsageReportUpdatedAtQuery(baseOptions?: Apollo.QueryHookOptions<GetLatestQuestionQSetUsageReportUpdatedAtQuery, GetLatestQuestionQSetUsageReportUpdatedAtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestQuestionQSetUsageReportUpdatedAtQuery, GetLatestQuestionQSetUsageReportUpdatedAtQueryVariables>(GetLatestQuestionQSetUsageReportUpdatedAtDocument, options);
      }
export function useGetLatestQuestionQSetUsageReportUpdatedAtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestQuestionQSetUsageReportUpdatedAtQuery, GetLatestQuestionQSetUsageReportUpdatedAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestQuestionQSetUsageReportUpdatedAtQuery, GetLatestQuestionQSetUsageReportUpdatedAtQueryVariables>(GetLatestQuestionQSetUsageReportUpdatedAtDocument, options);
        }
// @ts-ignore
export function useGetLatestQuestionQSetUsageReportUpdatedAtSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLatestQuestionQSetUsageReportUpdatedAtQuery, GetLatestQuestionQSetUsageReportUpdatedAtQueryVariables>): Apollo.UseSuspenseQueryResult<GetLatestQuestionQSetUsageReportUpdatedAtQuery, GetLatestQuestionQSetUsageReportUpdatedAtQueryVariables>;
export function useGetLatestQuestionQSetUsageReportUpdatedAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestQuestionQSetUsageReportUpdatedAtQuery, GetLatestQuestionQSetUsageReportUpdatedAtQueryVariables>): Apollo.UseSuspenseQueryResult<GetLatestQuestionQSetUsageReportUpdatedAtQuery | undefined, GetLatestQuestionQSetUsageReportUpdatedAtQueryVariables>;
export function useGetLatestQuestionQSetUsageReportUpdatedAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestQuestionQSetUsageReportUpdatedAtQuery, GetLatestQuestionQSetUsageReportUpdatedAtQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestQuestionQSetUsageReportUpdatedAtQuery, GetLatestQuestionQSetUsageReportUpdatedAtQueryVariables>(GetLatestQuestionQSetUsageReportUpdatedAtDocument, options);
        }
export type GetLatestQuestionQSetUsageReportUpdatedAtQueryHookResult = ReturnType<typeof useGetLatestQuestionQSetUsageReportUpdatedAtQuery>;
export type GetLatestQuestionQSetUsageReportUpdatedAtLazyQueryHookResult = ReturnType<typeof useGetLatestQuestionQSetUsageReportUpdatedAtLazyQuery>;
export type GetLatestQuestionQSetUsageReportUpdatedAtSuspenseQueryHookResult = ReturnType<typeof useGetLatestQuestionQSetUsageReportUpdatedAtSuspenseQuery>;
export type GetLatestQuestionQSetUsageReportUpdatedAtQueryResult = Apollo.QueryResult<GetLatestQuestionQSetUsageReportUpdatedAtQuery, GetLatestQuestionQSetUsageReportUpdatedAtQueryVariables>;
export const GetShortQuestionnaireSummaryReportDocument = gql`
    query getShortQuestionnaireSummaryReport($input: GetShortQuestionnaireSummaryReportInput!) {
  reportGetShortQuestionnaireSummaryReport(input: $input) {
    age {
      ...shortQuestionnaireSection
    }
    highestEducationLevel {
      ...shortQuestionnaireSection
    }
    currentOrganization {
      ...shortQuestionnaireSection
    }
    examAttendingObjectives {
      ...shortQuestionnaireSection
    }
    locationSatisfaction {
      ...shortQuestionnaireSection
    }
    staffServicesSatisfaction {
      ...shortQuestionnaireSection
    }
    systemUsabilitySatisfaction {
      ...shortQuestionnaireSection
    }
    systemStabilitySatisfaction {
      ...shortQuestionnaireSection
    }
  }
}
    ${ShortQuestionnaireSectionFragmentDoc}`;

/**
 * __useGetShortQuestionnaireSummaryReportQuery__
 *
 * To run a query within a React component, call `useGetShortQuestionnaireSummaryReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShortQuestionnaireSummaryReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShortQuestionnaireSummaryReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetShortQuestionnaireSummaryReportQuery(baseOptions: Apollo.QueryHookOptions<GetShortQuestionnaireSummaryReportQuery, GetShortQuestionnaireSummaryReportQueryVariables> & ({ variables: GetShortQuestionnaireSummaryReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShortQuestionnaireSummaryReportQuery, GetShortQuestionnaireSummaryReportQueryVariables>(GetShortQuestionnaireSummaryReportDocument, options);
      }
export function useGetShortQuestionnaireSummaryReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShortQuestionnaireSummaryReportQuery, GetShortQuestionnaireSummaryReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShortQuestionnaireSummaryReportQuery, GetShortQuestionnaireSummaryReportQueryVariables>(GetShortQuestionnaireSummaryReportDocument, options);
        }
// @ts-ignore
export function useGetShortQuestionnaireSummaryReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetShortQuestionnaireSummaryReportQuery, GetShortQuestionnaireSummaryReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetShortQuestionnaireSummaryReportQuery, GetShortQuestionnaireSummaryReportQueryVariables>;
export function useGetShortQuestionnaireSummaryReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShortQuestionnaireSummaryReportQuery, GetShortQuestionnaireSummaryReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetShortQuestionnaireSummaryReportQuery | undefined, GetShortQuestionnaireSummaryReportQueryVariables>;
export function useGetShortQuestionnaireSummaryReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShortQuestionnaireSummaryReportQuery, GetShortQuestionnaireSummaryReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShortQuestionnaireSummaryReportQuery, GetShortQuestionnaireSummaryReportQueryVariables>(GetShortQuestionnaireSummaryReportDocument, options);
        }
export type GetShortQuestionnaireSummaryReportQueryHookResult = ReturnType<typeof useGetShortQuestionnaireSummaryReportQuery>;
export type GetShortQuestionnaireSummaryReportLazyQueryHookResult = ReturnType<typeof useGetShortQuestionnaireSummaryReportLazyQuery>;
export type GetShortQuestionnaireSummaryReportSuspenseQueryHookResult = ReturnType<typeof useGetShortQuestionnaireSummaryReportSuspenseQuery>;
export type GetShortQuestionnaireSummaryReportQueryResult = Apollo.QueryResult<GetShortQuestionnaireSummaryReportQuery, GetShortQuestionnaireSummaryReportQueryVariables>;
export const GetStandardQuestionnaireSummaryReportDocument = gql`
    query getStandardQuestionnaireSummaryReport($input: GetStandardQuestionnaireSummaryReportInput!) {
  reportGetStandardQuestionnaireSummaryReport(input: $input) {
    age {
      ...standardQuestionnaireSection
    }
    highestEducationLevel {
      ...standardQuestionnaireSection
    }
    currentOrganization {
      ...standardQuestionnaireSection
    }
    examAttendingObjectives {
      ...standardQuestionnaireSection
    }
    locationSatisfaction {
      ...standardQuestionnaireSection
    }
    staffServicesSatisfaction {
      ...standardQuestionnaireSection
    }
    systemUsabilitySatisfaction {
      ...standardQuestionnaireSection
    }
    systemStabilitySatisfaction {
      ...standardQuestionnaireSection
    }
    major {
      ...standardQuestionnaireSection
    }
    examAttempted {
      ...standardQuestionnaireSection
    }
    workExperience {
      ...standardQuestionnaireSection
    }
    examPreparations {
      ...standardQuestionnaireSection
    }
  }
}
    ${StandardQuestionnaireSectionFragmentDoc}`;

/**
 * __useGetStandardQuestionnaireSummaryReportQuery__
 *
 * To run a query within a React component, call `useGetStandardQuestionnaireSummaryReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStandardQuestionnaireSummaryReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStandardQuestionnaireSummaryReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStandardQuestionnaireSummaryReportQuery(baseOptions: Apollo.QueryHookOptions<GetStandardQuestionnaireSummaryReportQuery, GetStandardQuestionnaireSummaryReportQueryVariables> & ({ variables: GetStandardQuestionnaireSummaryReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStandardQuestionnaireSummaryReportQuery, GetStandardQuestionnaireSummaryReportQueryVariables>(GetStandardQuestionnaireSummaryReportDocument, options);
      }
export function useGetStandardQuestionnaireSummaryReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStandardQuestionnaireSummaryReportQuery, GetStandardQuestionnaireSummaryReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStandardQuestionnaireSummaryReportQuery, GetStandardQuestionnaireSummaryReportQueryVariables>(GetStandardQuestionnaireSummaryReportDocument, options);
        }
// @ts-ignore
export function useGetStandardQuestionnaireSummaryReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStandardQuestionnaireSummaryReportQuery, GetStandardQuestionnaireSummaryReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetStandardQuestionnaireSummaryReportQuery, GetStandardQuestionnaireSummaryReportQueryVariables>;
export function useGetStandardQuestionnaireSummaryReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStandardQuestionnaireSummaryReportQuery, GetStandardQuestionnaireSummaryReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetStandardQuestionnaireSummaryReportQuery | undefined, GetStandardQuestionnaireSummaryReportQueryVariables>;
export function useGetStandardQuestionnaireSummaryReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStandardQuestionnaireSummaryReportQuery, GetStandardQuestionnaireSummaryReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStandardQuestionnaireSummaryReportQuery, GetStandardQuestionnaireSummaryReportQueryVariables>(GetStandardQuestionnaireSummaryReportDocument, options);
        }
export type GetStandardQuestionnaireSummaryReportQueryHookResult = ReturnType<typeof useGetStandardQuestionnaireSummaryReportQuery>;
export type GetStandardQuestionnaireSummaryReportLazyQueryHookResult = ReturnType<typeof useGetStandardQuestionnaireSummaryReportLazyQuery>;
export type GetStandardQuestionnaireSummaryReportSuspenseQueryHookResult = ReturnType<typeof useGetStandardQuestionnaireSummaryReportSuspenseQuery>;
export type GetStandardQuestionnaireSummaryReportQueryResult = Apollo.QueryResult<GetStandardQuestionnaireSummaryReportQuery, GetStandardQuestionnaireSummaryReportQueryVariables>;
export const GetLongQuestionnaireSummaryReportDocument = gql`
    query getLongQuestionnaireSummaryReport($input: GetLongQuestionnaireSummaryReportInput!) {
  reportGetLongQuestionnaireSummaryReport(input: $input) {
    age {
      ...longQuestionnaireSection
    }
    highestEducationLevel {
      ...longQuestionnaireSection
    }
    major {
      ...longQuestionnaireSection
    }
    examProvince {
      ...longQuestionnaireSection
    }
    currentOccupation {
      ...longQuestionnaireSection
    }
    currentOrganization {
      ...longQuestionnaireSection
    }
    workExperience {
      ...longQuestionnaireSection
    }
    examAttempted {
      ...longQuestionnaireSection
    }
    examPreparations {
      ...longQuestionnaireSection
    }
    examAttendingObjectives {
      ...longQuestionnaireSection
    }
    examDevice {
      ...longQuestionnaireSection
    }
    referralSource {
      ...longQuestionnaireSection
    }
    examReadiness {
      ...longQuestionnaireSection
    }
    locationSatisfaction {
      ...longQuestionnaireSection
    }
    staffServicesSatisfaction {
      ...longQuestionnaireSection
    }
    systemUsabilitySatisfaction {
      ...longQuestionnaireSection
    }
    systemStabilitySatisfaction {
      ...longQuestionnaireSection
    }
  }
}
    ${LongQuestionnaireSectionFragmentDoc}`;

/**
 * __useGetLongQuestionnaireSummaryReportQuery__
 *
 * To run a query within a React component, call `useGetLongQuestionnaireSummaryReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLongQuestionnaireSummaryReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLongQuestionnaireSummaryReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLongQuestionnaireSummaryReportQuery(baseOptions: Apollo.QueryHookOptions<GetLongQuestionnaireSummaryReportQuery, GetLongQuestionnaireSummaryReportQueryVariables> & ({ variables: GetLongQuestionnaireSummaryReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLongQuestionnaireSummaryReportQuery, GetLongQuestionnaireSummaryReportQueryVariables>(GetLongQuestionnaireSummaryReportDocument, options);
      }
export function useGetLongQuestionnaireSummaryReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLongQuestionnaireSummaryReportQuery, GetLongQuestionnaireSummaryReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLongQuestionnaireSummaryReportQuery, GetLongQuestionnaireSummaryReportQueryVariables>(GetLongQuestionnaireSummaryReportDocument, options);
        }
// @ts-ignore
export function useGetLongQuestionnaireSummaryReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLongQuestionnaireSummaryReportQuery, GetLongQuestionnaireSummaryReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetLongQuestionnaireSummaryReportQuery, GetLongQuestionnaireSummaryReportQueryVariables>;
export function useGetLongQuestionnaireSummaryReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLongQuestionnaireSummaryReportQuery, GetLongQuestionnaireSummaryReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetLongQuestionnaireSummaryReportQuery | undefined, GetLongQuestionnaireSummaryReportQueryVariables>;
export function useGetLongQuestionnaireSummaryReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLongQuestionnaireSummaryReportQuery, GetLongQuestionnaireSummaryReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLongQuestionnaireSummaryReportQuery, GetLongQuestionnaireSummaryReportQueryVariables>(GetLongQuestionnaireSummaryReportDocument, options);
        }
export type GetLongQuestionnaireSummaryReportQueryHookResult = ReturnType<typeof useGetLongQuestionnaireSummaryReportQuery>;
export type GetLongQuestionnaireSummaryReportLazyQueryHookResult = ReturnType<typeof useGetLongQuestionnaireSummaryReportLazyQuery>;
export type GetLongQuestionnaireSummaryReportSuspenseQueryHookResult = ReturnType<typeof useGetLongQuestionnaireSummaryReportSuspenseQuery>;
export type GetLongQuestionnaireSummaryReportQueryResult = Apollo.QueryResult<GetLongQuestionnaireSummaryReportQuery, GetLongQuestionnaireSummaryReportQueryVariables>;
export const ExportQuestionnaireSummaryReportDocument = gql`
    mutation exportQuestionnaireSummaryReport($input: ExportQuestionnaireSummaryReportInput!) {
  reportExportQuestionnaireSummaryReport(input: $input) {
    signedUrl
  }
}
    `;
export type ExportQuestionnaireSummaryReportMutationFn = Apollo.MutationFunction<ExportQuestionnaireSummaryReportMutation, ExportQuestionnaireSummaryReportMutationVariables>;

/**
 * __useExportQuestionnaireSummaryReportMutation__
 *
 * To run a mutation, you first call `useExportQuestionnaireSummaryReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportQuestionnaireSummaryReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportQuestionnaireSummaryReportMutation, { data, loading, error }] = useExportQuestionnaireSummaryReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportQuestionnaireSummaryReportMutation(baseOptions?: Apollo.MutationHookOptions<ExportQuestionnaireSummaryReportMutation, ExportQuestionnaireSummaryReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportQuestionnaireSummaryReportMutation, ExportQuestionnaireSummaryReportMutationVariables>(ExportQuestionnaireSummaryReportDocument, options);
      }
export type ExportQuestionnaireSummaryReportMutationHookResult = ReturnType<typeof useExportQuestionnaireSummaryReportMutation>;
export type ExportQuestionnaireSummaryReportMutationResult = Apollo.MutationResult<ExportQuestionnaireSummaryReportMutation>;
export type ExportQuestionnaireSummaryReportMutationOptions = Apollo.BaseMutationOptions<ExportQuestionnaireSummaryReportMutation, ExportQuestionnaireSummaryReportMutationVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    